import axios, { AxiosError, AxiosResponse } from 'axios';
import {
  FileUploadInterface,
  Photo,
  LocalUploadInterface,
} from '../models/Profile';
import {
  Activity,
  ActivityFormValues,
  FilterAssetsDetailsI,
} from '../models/activity';
import {
  HFCServiceInfo,
  HFCShipperInfo,
  ReceivingDelivery,
  ReceivingDeliveryDelete,
} from '../models/ReceivingDelivery';
import {
  User,
  GetSingleUserById,
  GetCurrentUser,
  SetCurrentUser,
  editSingleUserById,
  InstantPageUser,
} from '../models/user';
import { store } from '../stores/store';
import { Vault } from './../models/vault';
import { Department } from '../models/department';
import { Customer } from '../models/customer';
import { NameInterface, WorkLevel, WorkLevelItem } from '../models/workLevel';
import { Device } from '../models/device';
import { shelfRack } from './../models/shelfRack';
import {
  Template,
  TemplateSubTasks,
  AssetType,
  elementTypes,
  TemplateTask,
  WorkflowElement,
  WorkflowOptions,
  CloneStructure,
  WorkFlowSubTasks,
  WorkFlowTemplate,
  ParallelTask,
} from '../models/template';
import { DeliveryRequest, ShippingRequest } from '../models/deliveryRequest';
import { EmailNew } from '../models/EmailNew';
import {
  RoleComponents,
  RolePages,
  Roles,
  RolesAndPermissionsID,
} from './../models/rolesAndPermissions';
import { v4 as uuid } from 'uuid';
import { RejectionComment } from '../models/RejectionComment';
import { VerifyInterface } from '../models/tabverify';
import {
  MetaDataAT,
  MetaDataET,
  MetaDataOptions,
  PostFilteredItemDetailsTypes,
} from '../models/metaDataConfig';
import { MetaDataElement } from './../models/metaDataConfig';
import { historyPayloadType, HistoryViewItemLevel } from '../models/history';
import {
  PinnedInterface,
  pivotData,
} from '../../features/PivotReports/PivotStore';
import {
  ItemIdArray,
  listOfTenantsType,
  DepartmentList,
  OrderRegisterPayLoadType,
  InventoryDelivery_DeliveryPayload,
  roleSettingType,
  scheduleTabDataType,
  rescheduleTasksPayloadType,
  loginCred,
  metadataType,
  assignUserType,
  itemDetailsType,
  physicalAssetsType,
  HFCphysicalAssetsType,
  activeOrderType,
  FilesFolderType,
  itemDeleteDetailsType,
  itemDeleteResponse,
  workFlowUpdateResponse,
  appLogoType,
  uploadFileType,
  nfaiPDF2CSVtype,
  acquisitionScanType,
  registerScanResponse,
  addItemGroupRes,
  cutlistDetailsType,
  vaultListType,
  hfcOutwardRegisterPayload,
  circuitCreationPOST,
  circuitType,
  HFCmetadataType,
  NFAIworkFlowUpdateResponse,
  // tagValidationType,
} from './types';
import { manDaysType, operatorPerformanceType,frrReportAddress,pcrCommentsPayload,pcrReportdetails,FrrInformData  } from '../models/Restoration';
import {
  adlEmployeeDetails,
  employeeLockedInfo,
  shiftMasterData,
  shiftRoasterChangeData,
  shiftRoasterData,
  shiftRoasterExt,
  ShiftUpdate,
} from '../models/adlData';
import { PcProcessCsvReport } from '../../features/PC_Process_CsvReport/types';
import { ReelInformation } from '../../features/MediaAssets/Sections/Nfai_AV_SyncUpload';
import { InventoryList, InventoryListDetails, MetaDataTemplate } from '../models/TitleCreate';
import { qtSubtaskTypes } from '../../features/SmartTracker/smarttrackerType';
import { TimeSheetData, UpdatedTimeSheetData } from '../../features/MediaAssets/NFAI_Report/NFAI_TimeSheet/TimeSheet';
import { cutlistCompleteTypes, reAllocationTypes } from '../stores/CRMStore/types';
import { NewTimeSheetEntry, NFAIProductivityStatusCreate } from '../../features/MediaAssets/NFAI_Report/NFAI_TimeSheet/NFAITimeSheetWorkflow/types';
if (window.location.hostname === 'dev.vms-sandbox.com') {
  axios.defaults.baseURL = 'https://dev-api.vms-sandbox.com/api';
} else if (window.location.hostname === 'vms-prasad.com') {
  axios.defaults.baseURL = 'https://vms-prasad.com:5000/api';
} else if (window.location.hostname === 'preprod.vms-sandbox.com') {
  axios.defaults.baseURL = 'https://preprod-api.vms-sandbox.com/api';
  // axios.defaults.baseURL = "https://prod-api.vms-sandbox.com/api";
} else if (window.location.hostname === '172.16.0.118' && window.location.port==='9000') {
  axios.defaults.baseURL = 'http://172.16.0.118:5000/api';
} 
else if (window.location.hostname === '10.20.60.69' && window.location.port==='9000') {
  axios.defaults.baseURL = 'http://10.20.60.69:5000/api';
}
else if (window.location.hostname === '10.20.60.69' && window.location.port==='3000') {
  axios.defaults.baseURL = 'http://10.20.60.69:6500/api';
}
else if (window.location.hostname === '10.20.60.69' && window.location.port==='7000') {
  axios.defaults.baseURL = 'http://10.20.60.69:7500/api';
}
else if (window.location.hostname === '10.20.60.69' && window.location.port==='4000') {
  axios.defaults.baseURL = 'http://10.20.60.69:4500/api';
}
else if (window.location.hostname === '10.20.60.69' && window.location.port==='8500') {
  axios.defaults.baseURL = 'http://10.20.60.69:8080/api';
}
else if (window.location.hostname === '172.16.0.131' && window.location.port==='3000') {
  axios.defaults.baseURL = 'http://172.16.0.131:8080/api';
}
else if (window.location.hostname === '172.16.0.118' && window.location.port==='8500') {
  axios.defaults.baseURL = 'http://172.16.0.118:8080/api';
}
else if (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '172.16.0.138' ||
  window.location.hostname === '172.16.0.139' ||
  window.location.hostname === '172.16.0.135' ||
  window.location.hostname === '172.16.0.132' ||
  window.location.hostname === '172.16.0.137' ||
  window.location.hostname === '172.16.0.146' 
) {
  // axios.defaults.baseURL = 'https://vms-sandbox.com:3000/api';
  axios.defaults.baseURL = 'http://172.16.0.131:5000/api';
// axios.defaults.baseURL = 'http://192.168.0.189:5000/api';
}
 else if (
  window.location.hostname === '172.16.0.137' && window.location.port==='3000'
) {
axios.defaults.baseURL = 'http://172.16.0.131:7070/api'
} else if ( 
  window.location.hostname === '192.168.100.72' ||
  window.location.hostname === '172.24.224.1'
) {
  axios.defaults.baseURL = 'https://192.168.100.72:5000/api';
} else if (window.location.hostname === '103.133.158.81') { 
  axios.defaults.baseURL = 'https://103.133.158.81:5000/api';
} else if (window.location.hostname === '192.168.0.189') {
  axios.defaults.baseURL = 'http://192.168.0.189:5000/api';
} else {
  axios.defaults.baseURL = 'https://vms-sandbox.com:3000/api';
}

axios.interceptors.request.use((config: any) => {
  const token = store.commonStore.token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

axios.interceptors.response.use(
  async (response: any) => {
    return response;
  },
  (error: AxiosError) => {
    // const { data, status, config } = error.response!;
    // switch (status) {
    //     case 400:
    //         if (typeof data === 'string') {
    //             toast.error(data);
    //         }
    //         if (config.method === 'get' && data.errors?.hasOwnProperty('id')) {
    //             toast.error('Id not found');
    //             history.push('/not-found');
    //         }
    //         if (data.errors) {
    //             const modalStateErrors = [];
    //             for (const key in data.errors) {
    //                 if (data.errors[key]) {
    //                     modalStateErrors.push(data.errors[key])
    //                 }
    //             }
    //             toast.error('Validation Error');
    //             throw modalStateErrors.flat();
    //         }

    //         break;
    //     case 401:
    //         toast.error('Unauthorised');
    //         history.push('/');
    //         break;
    //     case 404:
    //         history.push('/not-found');
    //         toast.error('Not found');
    //         break;
    //     case 500:
    //         toast.error('Server Error');
    //         store.commonStore.setServerError(data);
    //         history.push('/server-error');
    //         break;
    // }
    return Promise.reject(error);
  },
);

const responseBody = <T>(response: AxiosResponse<T>) => response.data;

const requests = {
  get: <T>(url: string) => axios.get<T>(url).then(responseBody),
  post: <T>(url: string, body: {}) =>
    axios.post<T>(url, body).then(responseBody),
  put: <T>(url: string, body: {}) => axios.put<T>(url, body).then(responseBody),
  del: <T>(url: string) => axios.delete<T>(url).then(responseBody),
};

const Elements = {
  updateElement: (
    WorkFlowTemplate: activeOrderType,
    totalTaskActiveCount?: number,
    completeTaskActiveCount?: number,
  ) =>
    axios.put<void>(
      `/workflows/editworkflow/${
        WorkFlowTemplate.templateId
      }?totalTaskActiveCount=${
        totalTaskActiveCount || 0
      }&completeTaskActiveCount=${completeTaskActiveCount || 0}`,
      WorkFlowTemplate,
    ),
  getUpdateTaskCountAPI: (id: string) =>
    axios.get<{
      totalTaskActiveCount: number;
      completeTaskActiveCount: number;
    }>(`/Workflows/editWorkflowCount/${id}`),
};

const mediaAsset = {
  getItemMetadataDetails: (id: string) =>
    requests.get<MetaDataElement[]>(`/ItemGroups/ListMasterMetadata?Id=${id}`),
  getItemPropertyDetails: (id: string) =>
    requests.get<Activity>(`/ItemGroups/MasterItem?Id=${id}`),
  getMetaData: (id: any) => requests.get<any>(`/items/itemmetadata/${id}`),
  getHFCMetaData: (id: any) => requests.get<any>(`/HFCMediaServices/manageAsset?itemId=${id}`),
  putMetaData: (data: any) =>
    axios.post<void>(`/items/edititemmetadata/${data.id}`, data),
  uploadAssetCover: (payload: {
    id: string;
    preview: string;
    thumbnail: string;
  }) => axios.put<any>(`Items/UploadAssetCover`, payload),
};

const subtaskStatus = {
  subtaskElementsAPI: (subTaskIdNo: string) =>
    axios.get<any>(`/WorkflowSubTasks/${subTaskIdNo}`),
};

const workflowSubtasks = {
  uploadFiles: (element: TemplateSubTasks, subTaskIdNo: string) =>
    axios.put<void>(
      `/WorkflowSubTasks/Edit_Upload?SubTaskId=${subTaskIdNo}`,
      element,
    ),
  resolveOptionsAPI: (params: { subtaskId: string }) =>
    axios.get<any>(`/TemplateSubTasks/autoReject`, { params }),
  autoRejectUpdate: (params: { id: string; rejectToId: string }) =>
    axios.put<any[]>(`/TemplateSubTasks/autoReject/${params.id}`, null, {
      params: { rejectToId: params.rejectToId },
    }),
  updateElementDetailsAPI: (payload: { id: string; value: string }[]) =>
    axios.put<any[]>(`/WorkflowSubTasks/elementDetailsUpdate`, payload),
  updateFinishAPI: (payload: { subTaskId: string; isFinish: boolean }) =>
    axios.put<any[]>(`/TemplateSubTasks/finishSubtask`, payload),
  subtaskAloneAPI: (params: { id: string }) =>
    axios.get<WorkFlowSubTasks>(`/TemplateSubTasks/ById`, { params }),
};

const workflowStatus = {
  sendCommunicationTemp: (id: string) =>
    axios.post<void>(`/Communication/Subtask/${id}`),
  sendAPITemp: (id: string, itemId: string, SubTkStatus: string | null) =>
    axios.post<any>(
      `/APISettings/StatusUpdate?Id=${id}&ItemId=${itemId}&SubTkStatus=${SubTkStatus}`,
    ),
  workflowMetaData: (id: string) =>
    requests.get<any>(`/TemplateSubTasks/ListMetadata?id=${id}`),
  communication: (id: string) =>
    requests.get<string>(`/workflowsubtasks/component?id=${id}`),
  scheduleTabData: (templateId: string) =>
    axios.get<scheduleTabDataType[]>(
      `/WorkflowSubTasks/Schedule?templateId=${templateId}`,
    ),
  updateEditWorkflow: (data: any, itemId: string) =>
    axios.put<void>(`Workflows/editworkflowtask`, data, { params: itemId }),
  updateWorkflowProductionCount: (payload: {
    itemId: string;
    productionCount: number;
    totalTaskCount: number;
    totalTaskActiveCount: number;
    totalCompleteTaskCount: number;
  }) => axios.put<void>(`/Workflows/editWorkflowProductionCount`, payload),
  updateWorkflowInActive: (params: {
    itemId: string;
    templateId: string;
    isActive: boolean;
  }) => axios.put<void>(`/Workflows/itemWorkflowInActive`, null, { params }),
  updateIsReceiving: (params: { itemId: string }) =>
    axios.put<void>(`/TagOrder/IsReceiving`, null, { params }),
};

const apiSetting = {
  create: (apiData: any) =>
    axios.post<void>('/templatesubtasks/addapi', apiData),
  update: (apiData: any) =>
    axios.put<void>(
      `/templatesubtasks/updateapi/${apiData.subTaskId}`,
      apiData,
    ),
  delApiSetting: (delApiId: any) =>
    axios.delete<void>(`/templatesubtasks/deleteapi/${delApiId}`),
  getAnyApi: (url: string) => requests.get<any>(`${url}`),
  assetId: (id: string) =>
    axios.get<void>(`/TemplateSubTasks/APISetting?Id=${id}`),
  viewassetpage: (
    itemId: string,
    templateId: string,
    subtaskId: string,
    element: TemplateSubTasks,
  ) =>
    axios.post<any>(
      `/APISettings/APIValidation?itemId=${itemId}&templateId=${templateId}&subtaskId=${subtaskId}`,
      element,
    ),
};

const communicationApi = {
  create: (commData: any) =>
    axios.post<void>('/templatesubtasks/addcommunication', commData),
  update: (commData: any) =>
    axios.put<void>(
      `/templatesubtasks/updatecommunication/${commData.subTaskId}`,
      commData,
    ),
  delComm: (delCommId: any) =>
    axios.delete<void>(`/templatesubtasks/deletecommunication/${delCommId}`),
};

const updateCountOrder = {
  updateCount: (userId: any) =>
    requests.get<any>(`/Orders/DashboardCountById?UserId=${userId}`),
  NFAIRestroationupdateCount: (userId: any) =>
    axios.put<any>(`/Inventory/NFAIReportDashboardCount?UserId=${userId}`),
};

const Activities = {
  getFilterCountsAPI: (
    value: string,
    itemGroupId: string,
    filterCategory: string,
  ) =>
    requests.get<FilterAssetsDetailsI>(
      `/ViewItemLevelFilter/Count?searchvalue=${value}&ItemgroupId=${itemGroupId}&filter=${filterCategory}`,
    ),
  getItemGroupIdCountsAPI: (value: string) =>
    requests.get<
      {
        id: string;
        title: string;
      }[]
    >(`/ItemGroups/SearchFilter?searchvalue=${value}`),
  searchAndItemGroupsAndFilterAssetsAPI: (
    value: string,
    itemGroupId: string,
    filterCategory: string,
    pagenum: number,
    pageSize: number,
  ) =>
    requests.get<Activity[]>(
      `/ViewItemLevelFilter/Search?searchvalue=${value}&ItemgroupId=${itemGroupId}&filter=${filterCategory}&PageNumber=${pagenum}&PageSize=${pageSize}`,
    ),
  list: () => requests.get<Activity[]>(`/items/currentuseritem`),

  listPaginationLVP: (id: string, pagenum: number, pageSize: number) =>
    requests.get<Activity[]>(
      `/Pages/LVPCMS_NotFF?pagenumber=${pagenum}&pagesize=${pageSize}`,
    ),
  hfcInventoryList:(PageNumber:number, PageSize:number, payload:any[])=>axios.post(`/HFC/InventoryAssetList?PageNumber=${PageNumber}&PageSize=${PageSize}`, payload),
  hfcVaultInventoryList:(PageNumber:number, PageSize:number, payload:any[])=>axios.post(`/HFCMediaServices/moveToVaultList?PageNumber=${PageNumber}&PageSize=${PageSize}`, payload),
  hfcVaultCount:(payload:any[])=>axios.post(`/HFCMediaServices/moveToVaultListCount`, payload),
  hfcInventoryCount:(payload:any[])=>axios.post(`/HFCMediaServices/inventoryListCount`, payload),
  hfcShipperList:(PageNumber:number, PageSize:number, payload:any[])=>axios.post(`/HFCShipping/ShipperAssets?PageNumber=${PageNumber}&PageSize=${PageSize}`, payload),
  hfcShipperCount:(payload:any[])=>axios.post(`/HFCShipping/ShipperAssetsCount`, payload),
  hfcPullList:(PageNumber:number, PageSize:number, payload:any[])=> axios.post(`/HFCShipping/PullAssets?PageNumber=${PageNumber}&PageSize=${PageSize}`, payload),
  hfcPullCount:(payload:any[])=> axios.post(`/HFCShipping/PullAssetsCount`, payload),
  hfcShippinPrep:(PageNumber:number, PageSize:number, payload:any[])=> axios.post(`HFCShipping/ShippingPrepAssets?PageNumber=${PageNumber}&PageSize=${PageSize}`, payload),
  hfcShippinPrepCount:(payload:any[])=> axios.post(`/HFCShipping/ShippingPrepAssetsCount`, payload),
  hfcReceivingList:(PageNumber:number, PageSize:number, payload:any[])=>axios.post(`/HFCReceiving/ReceivingAssets?PageNumber=${PageNumber}&PageSize=${PageSize}`, payload),
  hfcReceivingCount:(payload:any[])=> axios.post(`/HFCReceiving/ReceivingAssetsCount`, payload),
  hfcAssignList:(PageNumber:number, PageSize:number, payload:any[])=>axios.post(`/HFCServiceRequest/ServiceRequestServicesAssets?PageNumber=${PageNumber}&PageSize=${PageSize}`, payload),
  hfcAssignCount:(payload:any[])=> axios.post(`/HFCServiceRequest/ServiceRequestServicesAssetsCount`, payload),
  hfcServiceList:(service:string, PageNumber:number, PageSize:number, payload:any[])=>axios.post(`/HFCServiceRequest/TaskWiseServicesAssets?service=${service}&PageNumber=${PageNumber}&PageSize=${PageSize}`, payload),
  hfcServiceCount:(service:string, payload:any[])=> axios.post(`/HFCServiceRequest/TaskWiseServicesAssetsCount?service=${service}`, payload),
  hfcReturnServiceList:(PageNumber:number, PageSize:number, payload:any[])=>axios.post(`/HFCServiceRequest/ReturnServicesAssets?PageNumber=${PageNumber}&PageSize=${PageSize}`, payload),
  hfcReturnServiceCount:(payload:any[])=> axios.post(`/HFCServiceRequest/ReturnServicesAssetsCount`, payload),
  listPagination: (params: {
    pageNo: number;
    pageSize: number;
    searchDate: string;
  }) =>
    requests.get<Activity[]>(
      `/Inventory/inventoryItems?pageNo=${params.pageNo}&pageSize=${params.pageSize}&searchDate=${params.searchDate}`,
    ),
    mepzItemFilter:(PageNumber:number, PageSize:number, payload:any[]) => axios.post(`Mepz/itemFilter?pageNumber=${PageNumber}&pageSize=${PageSize}`, payload),
    mepzchartRegistered:()=>axios.put(`/Mepz/DashboardChartsRegistered`),
    mepzChartCategory:(year:number)=>axios.put(`/Mepz/DashboardChartsCategory?year=${year}`),
    mepzCharts:(type:string)=>axios.put(`Mepz/DashboardCharts?type=${type}`),
    hfcShipping:(PageNumber:number, PageSize:number, payload:any[])=> axios.post(`/HFCShipping/ShippingAssets?PageNumber=${PageNumber}&PageSize=${PageSize}`, payload),
    hfcShippingCount:(payload:any[])=> axios.post(`/HFCShipping/ShippingAssetsCount`, payload),
    hfcDeliveryrequest:(PageNumber:number, PageSize:number, payload:any[])=> axios.post(`/HFCShipping/DeliveryRequestAssets?PageNumber=${PageNumber}&PageSize=${PageSize}`, payload),
    hfcDeliveryrequestCount:(payload:any[])=> axios.post(`/HFCShipping/DeliveryRequestAssetsCount`, payload),
    mepzUnsyncData:(pageNumber:number, pageSize:number)=> axios.get(`/Mepz/mapzUnSyncData?PageNumber=${pageNumber}&PageSize=${pageSize}`),
    mepzUnsyncDataCount:()=>axios.get(`/Mepz/mapzUnSyncDataCount`),
    mepzsyncData:(pageNumber:number, pageSize:number)=> axios.get(`/Mepz/mapzSyncData?PageNumber=${pageNumber}&PageSize=${pageSize}`),
    mepzsyncDataCount:()=>axios.get(`/Mepz/mapzSyncDataCount`),
  searchListLVPMS: () =>
    requests.get<number>(`/InventorySearch/Inv_SearchCount`),
  searchTagOrderDetails: (params: {
    item?: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<any[]>(`/TagOrder/Order`, { params }),
  sortTagOrderDetails: (params: {
    orderBy: string;
    name: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<number>(`/TagOrder/OrderSort`, { params }),
  countTagOrderDetails: (params: { item: string }) =>
    axios.get<number>(`/TagOrder/OrderCount`, { params }),
  searchListFF: (pagenum: number, data: any) =>
    axios.post<Activity[]>(
      `/Pages/LVPCMS_OnlyFFSearch?pagenumber=${pagenum}&pagesize=${5}`,
      data,
    ),
  sortFFList: (data: any, order: string, pagenum: number) =>
    requests.get<Activity[]>(
      `/pages/LVPCMS_OnlyFFSort?SortName=${data}&SortBy=${order}&PageNumber=${pagenum}&PageSize=${10}`,
    ),
  sortNotFFList: (data: any, order: string, pagenum: number) =>
    requests.get<Activity[]>(
      `/pages/LVPCMS_NotFFSort?SortName=${data}&SortBy=${order}&PageNumber=${pagenum}&PageSize=${10}`,
    ),
  details: (id: string) => axios.get<Activity>(`/items/${id}`),
  // HFCdetails: (id: string) => axios.get<Activity>(`/HFCMediaServices/manageAsset?itemId=${id}`),
  detailsForOrders: (id: string) =>
    requests.get<Activity>(`/items/itemorder/${id}`),
  update: (activity: ActivityFormValues) =>
    requests.put<void>(`/items/${activity.id}`, activity),
  digitalUpdateFile: (payload: uploadFileType) =>
    requests.post(`/Items/AddItemFiles?id=${payload.id}`, payload),
  HFCDigitalUpdateFile: (payload: uploadFileType) =>
  requests.put(`/HFCShipping/ShippingFileUpload?shippingId=${payload.id}`, payload),
  physicalAsset: (id: string, data: any) =>
    axios.put(`/Items/PhysicalAsset/${id}`, data),
  attend: (id: string, userId: string) =>
    requests.post<any>(`/items/${id}/assignuser/${userId}`, {}),
  attenddelete: (id: string, userId: string) =>
    requests.del<void>(`/items/${id}/removedassignuser/${userId}`),
  listInwards: () => requests.get<Activity[]>(`/items/inwarditem`),
  listOutwards: () => requests.get<Activity[]>(`/items/outwarditem`),
  listDeliveries: () => requests.get<Activity[]>(`/items/deliveryitem`),
  downloadFiles: (data: any) => axios.get<any>(data, { responseType: 'blob' }),
  attachmentHistory: (id: string) =>
    requests.get<FileUploadInterface[]>(`/items/histroyphoto/${id}`),
  voiceHistory: (id: string) =>
    requests.get<FileUploadInterface[]>(`/items/histroyfile/${id}`),  
  viewHistorySearchAPI: (params: {
    itemid: string;
    values: string | null;
    pagenumber: number;
    pagesize: number;
  }) => axios.get<HistoryViewItemLevel[]>(`/History/Search`, { params }),
  viewHistorySortAPI: (params: {
    itemid: string;
    sortvalue: string;
    sortby: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<HistoryViewItemLevel[]>(`/History/Sort`, { params }),
  viewHistoryCountAPI: (params: { itemid: string; values: string | null }) =>
    axios.get<number>(`/History/Count`, { params }),
  // view template
  viewTemplateSearchAPI: (params: {
    ItemId: string;
    searchvalue: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<HistoryViewItemLevel[]>(`/ViewTemplate`, { params }),
  viewTemplateSortAPI: (params: {
    ItemId: string;
    SortValue: string;
    SortBy: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<HistoryViewItemLevel[]>(`/ViewTemplate/Sort`, { params }),
  viewTemplateCountAPI: (params: { ItemId: string; searchvalue: string }) =>
    axios.get<number>(`/ViewTemplate/Count`, { params }),
  trackGate: (id: string, gate: string, direction: string) =>
    axios.post<string>(
      `apisettings/updateitemhistoryapi?id=${id}&Gate=${gate}&direction=${direction}`,
    ),
  newHandOverStatus: (payload: {
    id: string;
    receiver: string;
    receiver_Status: string;
    issuer: string;
    movementdate: string;
  }) => axios.put<any>('Items/HandOverReturnStatus', payload),
  onlyHistory: (id: string, data: any) =>
    axios.post<void>(`/items/updateitemhistoryalone?id=${id}`, data),
  usertracker: (id: string) =>
    requests.get<any[]>(`/tracker/usertracker?itemid=${id}`),
  timedifference: (id: string, userid: string) =>
    requests.get<any[]>(
      `/items/historyusertimedifference?id=${id}&userid=${userid}`,
    ),
  singleItemMetaData: (id: string) =>
    requests.get<MetaDataElement>(`/templatemetadataclone/${id}`),

  //inventory infographic counts
  loadInventoryDoughnutGraphics: () =>
    requests.get<any>('/Orders/InvInfographicPie'),
  loadInventoryInfoGraphics: () =>
    requests.get<any>('/orders/invinfographiccounts'),
  loadOrderInfoGraphics: () =>
    requests.get<any>('/orders/orderinfographiccounts'),
  loadProductionInfoGraphics: () =>
    requests.get<any>('/orders/productioninfocount'),
  updateAssetMetaData: (id: string) =>
    axios.put<void>(`/pivotreport/updateitemmetadata?id=${id}`),
  inventoryCount: (search: string) =>
    requests.get<number>(
      `/Inventory/inventoryItemsSearchCount?searchDate=${search}`,
    ),
  itemExistAPI: (params: { userId: string; referenceId: string }) =>
    axios.get<string>(`/Items/filterScanSearch`, { params }),
  assetScan: (params: { itemId: string; scanUserId: string }) =>
    axios.get<string>(`AssetReport/ItemReceiverStatus`, { params }),
  inventorySearchList: (headerName: string) =>
    axios.get<any>(`/AssetReport/ItemDropDownSearch?headerName=${headerName}`),
  // ------ inventory ------ //
  searchInventoryReportsTableDetails: (
    params: {
      item?: string;
      PageNumber: number;
      PageSize: number;
    },
    name: string,
  ) => axios.get<any[]>(`/InventoryReports/${name}`, { params }),
  sortInventoryReportsTableDetails: (
    params: {
      orderBy: string;
      name: string;
      PageNumber: number;
      PageSize: number;
    },
    name: string,
  ) => axios.get<number>(`/InventoryReports/${name}/sort`, { params }),
  countInventoryReportsTableDetails: (
    params: {
      item: string;
    },
    name: string,
  ) => axios.get<number>(`/InventoryReports/${name}/count`, { params }),

  // ------ order reports ------ //

  searchOrderReportsTableDetails: (
    params: {
      item?: string;
      PageNumber: number;
      PageSize: number;
    },
    name: string,
  ) => axios.get<any[]>(`/OrdersReport/${name}`, { params }),
  sortOrderReportsTableDetails: (
    params: {
      orderBy: string;
      name: string;
      PageNumber: number;
      PageSize: number;
    },
    name: string,
  ) => axios.get<number>(`/OrdersReport/${name}/sort`, { params }),
  countOrderReportsTableDetails: (
    params: {
      item: string;
    },
    name: string,
  ) => axios.get<number>(`/OrdersReport/${name}/count`, { params }),

  movementview: (itemId: string) =>
    axios.get<string>(`/Tracker/MovementTracker?ItemId=${itemId}`),
  chart2: () => axios.get(`/ProdPlanControlller/Chart2`),
  chart3: () => axios.get(`/ProdPlanControlller/Chart3`),
  inventorySortData: (
    header: any,
    sortBy: string,
    pageNo: number,
    pageSize: number,
  ) =>
    requests.get<Activity[]>(
      `/Inventory/inventoryItemsSort?sortBy=${sortBy}&header=${header}&pageNo=${pageNo}&pageSize=${pageSize}`,
    ),
    HFCinventorySortData: (
      header: any,
      sortBy: boolean,
      pageNo: number,
      pageSize: number,
    ) =>
      requests.get<Activity[]>(
        `/HFCMediaServices/inventoryListSort?Header=${header}&Ascending=${sortBy}&PageNumber=${pageNo}&PageSize=${pageSize}`,
      ),
    
  movementtrackerWithCountReturn: (id: string) =>
    requests.get<string>(`/Tracker/MovementTrackerCount?ItemId=${id}`),
  getInventoryTitleAlone: (params: { title: string; assetInVault: string }) =>
    axios.get<string>(`/AssetReport/ItemTitle`, { params }),
  AlterAssetInVault: (assetInVault: {
    itemIds: string[];
    assetInVault: string;
  }) =>
    axios.put<void>(
      `/AssetReport/AssetInVault?assetInVault=${assetInVault.assetInVault}`,
      assetInVault.itemIds,
    ),
  ItemAccessPermit: (payload: any) =>
    axios.post(`/AssetReport/ItemAccessPermit`, payload),
  scanUser: (params: { scanUserId: string }) =>
    axios.get(`AssetReport/UserCustomerConfirm`, { params }),
};

const Tag = {
  listItemPagination: (pagenum: number) =>
    requests.get<Activity[]>(
      `/TagOrder/ListTag?PageNumber=${pagenum}&PageSize=${5}`,
    ),
  sortList: (data: any, order: string, pagenum: number) =>
    requests.get<Activity[]>(
      `/TagOrder/SortTag?orderBy=${order}&name=${data}&PageNumber=${pagenum}&PageSize=${5}`,
    ),
  tagCount: () => requests.get<number>(`/TagOrder/TagCount`),
  searchCount: (data: any) =>
    axios.get<number>(`/TagOrder/SearchTagCount?item=${data}`),
  searchList: (pagenum: number, data: any) =>
    axios.get<Activity[]>(
      `/TagOrder/SearchTag?item=${data}&pagenumber=${pagenum}&pagesize=${5}`,
    ),
};

const ProdPlanning = {
  listProductionType: () => axios.get<any>(`ProdPlanControlller/L2`),
  NFAIListProductionType: () => axios.get<any>(`NFAI/Level2`),
  listProductionTask: (data: string) =>
    axios.get<any>(`/ProdPlanControlller/L3`, {
      params: { currentTask: data },
    }),
    SmartTrackerlistsubTask: (data: string) =>
    axios.get<any>(`/NFAI/Level3?currentTask=${data}`),
  NFAIListProductionTask: (data: string) =>
    axios.get<any>(`NFAI/Level3`, {
      params: { currentTask: data },
    }),
  listProductionPlanning: (params: any) =>
    axios.get<Activity[]>(`/ProdPlanControlller`, { params }),
  NFAIListProductionPlanning: (params: any) =>
    axios.get<Activity[]>(`NFAI/ProdPlanItems`, { params }),
  searchProductionPlanning: (params: {
    currentTask: string;
    currentSubTask: string;
    searchvalue: any;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<Activity[]>(`/ProdPlanControlller/Search`, { params }),
  searchCountProduction: (params: {
    currentTask: string;
    currentSubTask: string;
    searchvalue: any;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<number>(`/ProdPlanControlller/SearchCount`, { params }),
  sortProductionPlanning: (params: {
    currentTask: string;
    currentSubTask: string;
    orderBy: string;
    name: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<Activity[]>(`ProdPlanControlller/Sort`, { params }),
  listProductionPlanningTemplate: (params: any) =>
    axios.get<any>(`/ProdPlanControlller/TemplateL2`, { params }),
  listProductionTaskTemplate: (params: any) =>
    axios.get<any>(`/ProdPlanControlller/TemplateL3`, {
      params,
    }),
};
const CreateOrder = {
  listItemPagination: (pagenum: number, pagesize: number) =>
    requests.get<Activity[]>(
      `/TagOrder/CreateOrder?PageNumber=${pagenum}&PageSize=${pagesize}`,
    ),
  tagCount: () => requests.get<number>(`/TagOrder/CreateOrderCount`),
  OrderPagination: (itemId: string, pagenumber: number) =>
    axios.get<Activity[]>(
      `History/Order?itemid=${itemId}&PageNumber=${pagenumber}&PageSize=${4}`,
    ),
  orderCount: (itemId: string) =>
    axios.get<number>(`History/OrderCount?itemid=${itemId}`),
  sortList: (data: any, order: string, pagenum: number) =>
    requests.get<Activity[]>(
      `/TagOrder/SortCreateOrder?orderBy=${order}&name=${data}&PageNumber=${pagenum}&PageSize=${5}`,
    ),
  searchCount: (data: any) =>
    axios.get<number>(`/TagOrder/CreateOrderSearchCount?item=${data}`),
  searchList: (pagenum: number, data: any) =>
    axios.get<Activity[]>(
      `/TagOrder/CreateOrderSearch?item=${data}&pagenumber=${pagenum}&pagesize=${5}`,
    ),
};
const Reject = {
  list: () => requests.get<RejectionComment[]>('/rejects'),
  details: (id: string) => requests.get<RejectionComment>(`/rejects/${id}`),
  createResolve: (resolveData: RejectionComment) =>
    axios.post<void>(`/rejects/addresolve?id=${resolveData.id}`, resolveData),
};

const Account = {
  list: () => requests.get<User[]>('/Account/GetUsers'),
  current: () => requests.get<GetCurrentUser>('/account/getcurrentuser'),
  DashboardCountUpdate:(userId:string)=>axios.put(`/Inventory/DashboardCount?UserId=${userId}`),

  details: (id: string) =>
    requests.get<GetSingleUserById>(`/account/getuserbyid?id=${id}`),
  listOfTenants: (params: listOfTenantsType) =>
    axios.get<string[]>(`/Account/UserCustomerName`, { params }),
  loginCustomerBased: (user: loginCred, customerName: string) =>
    requests.post<GetCurrentUser>(
      `/account/Login_CustomerBased?customer=${customerName}`,
      user,
    ),
  getUserIdByItemIdAllocate: (itemIds: ItemIdArray) =>
    axios.post<string[]>(`/AllocateUser/AllocateUser`, itemIds),
  getScannedItems: (qrCode: string[]) =>
    axios.post<string[]>(`/AllocateUser/ScannedItem`, qrCode),
  registerCustomerBased: (user: GetSingleUserById) =>
    requests.post<GetCurrentUser>('/Account/Register_CustomerBassed', user),
  updatecurrentuser: (currentUser: SetCurrentUser) =>
    requests.put<void>('/account/updatecurrentuser', currentUser),
  update: (userId: string, userinfo: editSingleUserById) =>
    requests.put<User>(`/account/updateuserbyid?id=${userId}`, userinfo),
  reset: (params: { id: string; password: string; newPassword: string }) =>
    axios.put<User>(
      `/Account/modifyPassword?id=${params.id}&password=${params.password}&newPassword=${params.newPassword}`,
    ),
  deleteUser: (userId: string) => axios.delete(`/Account/${userId}`),
  defaultPassword: (id: string) =>
    requests.put<User>(`/account/setdefaultpassword/id?id=${id}`, id),
  unBlock: (userId: string) =>
    axios.put<any>(`/Account/UnBlock?userId=${userId}`),
  allUsers: () => requests.get<User[]>('/account/allusers'),
  deletePhoto: (id: string) => axios.delete(`/Account/Photos?id=${id}`),
  InstantpageRegister: (params: InstantPageUser) =>
    axios.post(`/Account/instantRegister`, params),
  customersRegister: () => axios.get(`/Customers/Register`),
  CustomerBasedRoleId: () => axios.get(`/RolesAndPermissions/registerRole`),
  InstantpageTemplate: (data: any) =>
    axios.post(`/RolesAndPermissions/Template`, data),
  InstantpageFrontEndIds: (data: string) =>
    axios.get(`/RolesAndPermissions/FrontEndIds?roleId=${data}`),
  InstantpageAddFrontEndIds: (id: string, data: any) =>
    axios.post(`/RolesAndPermissions/AddFrontEndIds?roleId=${id}`, data),
  // defaultPassword: (userId: editSingleUserById) => requests.put<User>(`/account/setdefaultpassword/id?id=${userId.id}`,userId),
};

const ReceivingsDeliveries = {
  listPagination: (pagenum: number, pagesize: number) =>
    requests.get<ReceivingDelivery[]>(
      `/receivings?pagenumber=${pagenum}&PageSize=${pagesize}`,
    ),
  searchList: (params: {
    PageNumber: number;
    PageSize: number;
    receiving: any;
  }) =>
    axios.get<ReceivingDelivery[]>(`/receivings/search_receiving`, {
      params,
    }),
  sortList: (data: string, direction: string, pagenum: number) =>
    axios.post<ReceivingDelivery[]>(
      `/receivings/sort_receiving?sortby=${data}&orderby=${direction}&pagenumber=${pagenum}&pagesize=${5}`,
    ),
  details: (id: string) => requests.get<ReceivingDelivery>(`/Receivings/${id}`),
  create: (receivingdelivery: ReceivingDelivery) =>
    axios.post<void>('/receivings', receivingdelivery),
  updateReceivings: (receivingdelivery: ReceivingDelivery) =>
    axios.put<void>(
      `/Receivings/AddFilesWithData/${receivingdelivery.id}`,
      receivingdelivery,
    ),
  delete: (ReceivingDeliveryDelete: ReceivingDeliveryDelete) =>
    axios.put<void>(
      `/receivings/isdeleted/${ReceivingDeliveryDelete.id}`,
      ReceivingDeliveryDelete,
    ),
  deleteFile: (id: string) => requests.del(`/receivings/files/${id}`),
  searchCountReceiving: (data: any) =>
    requests.get<number>(`/Receivings/Search_ReceivingCount?receiving=${data}`),
  receivingCount: () => requests.get<number>(`/receivings/count`),
};

const Profiles = {
  get: (id: string) =>
    requests.get<GetSingleUserById>(`/account/getuserbyid?id=${id}`),
  uploadPhoto: (file: Blob) => {
    const formData = new FormData();
    formData.append('File', file);
    return axios.post<Photo>('photos', formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  setMainPhoto: (id: string) => requests.post(`/photos/${id}/setMain`, {}),
  setMainPhotoLocal: (path: string) =>
    axios.put(`/Account/SetMainPhoto?Url=${path}`),
  deletePhoto: (id: string) => requests.del(`/photos/${id}`),
  deletePhotoLocal: (path: string) =>
    axios.delete(`/Account/UserPhoto?Url=${path}`),
  addPhotoLocal: (payload: Photo) => axios.post(`/Account/AddPhoto`, payload),
  getAppLogo: () => axios.get<appLogoType>(`/Customers/Logo`),
  setAppLogo: (params: { Url: string }) =>
    axios.post<appLogoType>(`/Customers/Logo`, null, { params }),
  deleteAppLogo: (params: { Id: string }) =>
    axios.delete(`/Customers/Logo`, { params }),
};

const Files = {
  uploadFile: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post<FileUploadInterface>('fileupload', formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },

  uploadCameraImage: (file: Blob) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post<FileUploadInterface>('fileupload', formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  localFileUpload: (file: File | Blob, workLevel: string, item: string, name?:string) => {
    const formData = new FormData();
    if (file instanceof File) {
      formData.append('File', file);
    } else if (file instanceof Blob) {
      formData.append('File', file, 'image.png');
    }
    formData.append('WorkLevel', workLevel);
    formData.append('Item', item);
    formData.append('Tenant', store.userStore.user?.customerName || '');
    formData.append(
      'Path',
      store.commonStore.NFAIReportCustomer && name === 'Mastering Files' ?
      `D:\\FE\\build\\assets\\LocalStorage\\Mastering_Files\\${workLevel || uuid()}\\${item}`
      : store.commonStore.NFAIReportCustomer ? 
      `D:\\FE\\build\\assets\\LocalStorage\\${store.userStore.user?.customerName || uuid()}\\${workLevel || uuid()}\\${item}` :
       `D:\\FE\\Resto\\build\\assets\\LocalStorage\\${store.userStore.user?.customerName}\\${workLevel}\\${item}`,
    );
    return axios.post<LocalUploadInterface>('LocalFileUpload', formData, {
      headers: { 'Content-type': 'multipart/form-data' },
    });
  },
  updateLocalFileUpload: (registerId: string, itemId: string, path: string) => {
    axios.put<void>(
      `/LocalFileUpload/Update?registerid=${registerId}&itemid=${itemId}&path=${path}`,
    );
  },
  getLocalFiles: (itemId: string) =>
    axios.get<
      {
        files: {
          id: string;
          fileName: string;
          path: string;
          createdAt: string;
        }[];
        folderName: string;
      }[]
    >(`/LocalFileUpload/Item?item=${itemId}`),
  deleteLocalFile: (path: string) =>
    axios.delete(`/LocalFileUpload/Path?path=${path}`),
};

const Vaults = {
  list: () => requests.get<Vault[]>('/vaults'),
  details: (id: string) => requests.get<Vault>(`/vaults/${id}`),
  create: (Vault: Vault) => axios.post<void>('/vaults', Vault),
  update: (Vault: Vault) => axios.put<void>(`/vaults/${Vault.id}`, Vault),
  delete: (vault: Vault) =>
    axios.put<Vault>(`/vaults/isDeleted/${vault.id}`, vault),
  UpdateShelf: (Vault: Vault) => axios.post<void>(`/vaults/addshelf`, Vault),
  UpdateDeviceNew: (Device: Device) =>
    axios.post<void>(`/vaults/adddevice`, Device),
  vaultList: () => axios.get<vaultListType[]>('/HFC/vaultInfo'),
  rackList: (params: { vaultId: string }) =>
    axios.get<string[]>(`/HFC/rackNos`, { params }),
  shelfList: (params: { vaultId: string; rackNo: string }) =>
    axios.get<string[]>(`/HFC/shelfNos`, { params }),
};

const Departments = {
  list: () => requests.get<Department[]>('/departments'),
  details: (id: string) => requests.get<Department>(`/departments/${id}`),
  create: (Department: Department) =>
    axios.post<void>('/departments', Department),
  update: (Department: Department) =>
    axios.put<void>(`/departments/${Department.id}`, Department),
  delete: (Department: Department) =>
    axios.put<void>(`/departments/isdeleted/${Department.id}`, Department),
  getDepartmentByCustomer: (params: DepartmentList) =>
    axios.get<string[]>(`/Departments/Name`, { params }),
  MarkloginDepartment: (item: any) =>
    axios.get<any>(`/Departments/Name?customer=${item}`),
  MarkloginUserDetails: (item: string) =>
    axios.put<any>(`/Departments/UserDetails?departmentName`, item),
};

const Customers = {
  list: () => requests.get<Customer[]>('/customers'),
  details: (id: string) => requests.get<Customer>(`/customers/${id}`),
  create: (Customer: Customer) => axios.post<void>('/customers', Customer),
  update: (Customer: Customer) =>
    axios.put<void>(`/customers/${Customer.id}`, Customer),
  delete: (Customer: Customer) =>
    axios.put<void>(`/customers/isdeletecustomer/${Customer.id}`, Customer),
};

const WorkLevels = {
  lisInsideVaultWorklevel: () =>
    requests.get<WorkLevel[]>('/AssetReport/WorkLevel'),
  listAll: () => requests.get<WorkLevel[]>('/itemgroups/listall'),
  details: (id: string) => requests.get<WorkLevel>(`/itemgroups/${id}`),
  detailsItem: (id: string) =>
    requests.get<WorkLevelItem>(`/Masters/Items?Id=${id}`),
  mastersListAPI: (params: {
    name: string;
    componentName: string;
    filterColumn?: string;
    filterValue?: string;
    receivingDate?: string;
    returnDate?: string;
  }) => axios.get<any>(`/Masters/ItemsName`, { params }),
  getMasterColumn: (params: {
    masterName: string;
    componentName: string;
    filterColumn: string;
    filterValue: string;
  }) => axios.get<string[]>(`/HFC/assetDetails`, { params }),
  mastersListAcademyAPI: (params: {
    assetReportId: string;
    name: string;
    componentName: string;
    filterColumn: string;
    filterValue: string;
  }) => axios.get<string[]>(`/Masters/ItemsNameEdit`, { params }),
  masterRename: (params: { masterId: string; name: string }) =>
    axios.put<any>(`/Masters/Rename`, null, { params }),
  usersListAPI: (id: string) =>
    requests.get<WorkLevelItem>(`/RolesAndPermissions/UserName?roleName=${id}`),
  createDetailsItem: (id: string) =>
    requests.get<WorkLevelItem>(`/itemgroups/${id}`),
  create: (WorkLevel: WorkLevel) => axios.post<void>('/itemgroups', WorkLevel),
  update: (WorkLevel: WorkLevel) =>
    axios.put<void>(`/itemgroups/${WorkLevel.id}`, WorkLevel),
  updateItemLevel: (WorkLevel: WorkLevel) =>
    requests.post<void>(`/itemgroups/${WorkLevel.id}`, WorkLevel),
  delete: (WorkLevel: WorkLevel) =>
    axios.put<void>(`/itemgroups/isdeleted/${WorkLevel.id}`, WorkLevel),
  worklevelFromItem: (id: string) =>
    requests.get<any>(`/itemgroups/itemId/${id}`),
  loadClone: (payload: any) =>
    axios.post<VerifyInterface>('/items/itemclone', payload),
  loadName: (id: string) =>
    requests.get<NameInterface[]>(`/itemgroups/itemname/${id}`),
  loadMasters: () => requests.get<any>('/workflows/ismaster'),
  getAllMasterTitles: () => requests.get<any>('/Masters'),
  updateProductionCountViaSections: (taskCount: number) =>
    requests.put<any>(`/Orders/Item_Physical?taskcount=${taskCount}`, {}),
  viewItemGroupsSearchAPI: (params: {
    searchvalue: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<any>(`/ItemGroups/viewItemGroup`, { params }),
  viewItemGroupsCountAPI: (params: { searchvalue: string }) =>
    axios.get<any>(`/ItemGroups/viewItemGroup/count`, { params }),
  viewItemGroupsSortAPI: (params: {
    orderBy: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<any>(`/ItemGroups/viewItemGroup/sort`, { params }),
};

const Devices = {
  list: () => requests.get<Device[]>('/devices'),
  details: (id: string) => requests.get<Device>(`/devices/${id}`),
  update: (Device: Device) => axios.put<void>(`/devices/${Device.id}`, Device),
  delete: (Device: Device) =>
    axios.put<Device>(`/devices/isdeleted/${Device.id}`, Device),
};

const ShelfRack = {
  list: () => requests.get<shelfRack[]>('/shelfracks'),
  HFClist:()=> axios.get<shelfRack[]>(`HFCMovement/ShelfRack`),
  details: (id: string) => requests.get<shelfRack>(`/shelfracks/${id}`),
  update: (shelfRack: shelfRack) =>
    axios.put<void>(`/shelfracks/${shelfRack.id}`, shelfRack),
  delete: (shelfRack: shelfRack) =>
    axios.put<shelfRack>(`/shelfracks/isdeleted/${shelfRack.id}`, shelfRack),
};

const Order = {
  createOrder: (order: Activity) =>
    axios.post<string>('/items/updateitemorder', order),
  createOrderDelivery: (order: Activity, params: { id: string }) =>
    axios.post<string>('/Items/UpdateItemOrderDelivery', order, { params }),
  listOrderRegister: () => requests.get<any>(`/OrderRequest`),
  listApproveDelivery: () => requests.get<any>(`/OrderRequest/Approve`),
  listAssignPicker: () => requests.get<any>(`/OrderRequest/AssignPicker`),
  listCreateOrder: () => requests.get<any>(`/OrderRequest/CreateOrder`),
  listDelivery: () => requests.get<any>(`/OrderRequest/Delivery`),
};

const AssetTypes = {
  smartflowTemplate: () => axios.get('Templates/smartFlowTemplate'),
  listAssetTypes: () => requests.get<AssetType[]>('/AssetTypes/AssetTypeOnly'),
  assetTypeDetails: (id: string) =>
    requests.get<AssetType>(`/AssetTypes/${id}`),
  createAssetType: (assetType: AssetType) =>
    axios.post<AssetType>('/assettypes/', assetType),
  editAssetType: (assetType: AssetType) =>
    axios.put<AssetType>(`assettypes/${assetType.id}`, assetType),
  cloneAssetType: (parentId: string, childName: string) =>
    axios.post<void>(`/assettypes/clone?id=${parentId}&Clonename=${childName}`),
};

const MetaDataAssetTypes = {
  listMetaDataAssetTypes: () =>
    requests.get<MetaDataAT[]>('/AssetTypes/AssetTypeOnly'),
  getmetaDataAssetType: (id: string) =>
    requests.get<MetaDataAT>(`/AssetTypes/${id}`),
  searchisMasterAPI: (id: string) =>
    requests.get<string>(`Masters/MasterId?itemId=${id}`),
};

const ElementTypes = {
  listElementTypes: () => requests.get<elementTypes[]>('/elementtypes'),
  elementTypesDetails: (id: string) =>
    requests.get<elementTypes>(`/elementtypes/template/${id}`),
  createElementTypesUnderAssetType: (assettype: AssetType) =>
    axios.post<AssetType>('/assettypes/addelementtype/', assettype),
  editElementType: (elementtype: elementTypes) =>
    axios.put<elementTypes>(`/elementtypes/${elementtype.id}`, elementtype),
  getElementTypeMetaDataTemplate: (id: string) =>
    requests.get<elementTypes[]>(`/elementtypes/gettemplatemetadata/${id}`),
  getElementTypeByAssetType: (id: string) =>
    requests.get<elementTypes[]>(`/AssetTypes/GetElementType/${id}`),
  cloneElementType: (data: CloneStructure) =>
    axios.post<void>(`/elementtypes/clone`, data),
  elementDetails: (params: {
    itemId: string;
    templateId: string;
    templateElementId: string;
  }) => axios.get<any>(`/WorkflowSubTasks/elementDetails/`, { params }),
};
const MetaDataElementType = {
  reArrangeOrder: (params: any, elementId: string) =>
    axios.put<MetaDataET>(
      `/TemplateMetadata/indexRearrange/${elementId}`,
      null,
      { params },
    ),
  listMetaDataETDetails: (id: string) =>
    requests.get<MetaDataET>(`/ElementTypes/Metadata/${id}`),
  dynamicmetadataDetailsAPI: (params: {
    subTaskId: string;
    templateId: string;
    elementTypeId: string;
  }) => axios.get<any>(`/ElementTypes/dynamicMetadata`, { params }),
  parentDynamicmetadataDetailsAPI: (params: {
    templateId: string;
    elementTypeId: string;
    id: string;
  }) => axios.get<any>(`/TemplateElements/parentDynamicMetadata`, { params }),
};

const MetaDataElements = {
  elementDetails: (id: string) =>
    requests.get<MetaDataElement>(`/templatemetadata/${id}`),
  createElemUnderET: (metadataelem: MetaDataET) =>
    axios.post<MetaDataET>(
      `/elementtypes/addmetdata?id=${metadataelem.id}`,
      metadataelem,
    ),
  editElement: (element: MetaDataElement) =>
    axios.put<MetaDataElement>(
      `/templatemetadata/${element.elementId}`,
      element,
    ),
  deleteElement: (element: MetaDataElement) =>
    axios.delete<MetaDataElement>(`/TemplateMetadata/${element.elementId}`),
  elementToggleOffEditAPI: (elementId: string) =>
    axios.put(`/TemplateMetadata/toggleOnOff/${elementId}`),
};

const MetaDataOption = {
  createOptionsUnderElements: (element: MetaDataElement) =>
    axios.post<MetaDataElement>('/templatemetadata/addoptions', element),
  deleteOptionsAPI: (id: string) =>
    axios.delete<MetaDataOptions>(`/metadataoptions/${id}`),
};

const Templates = {
  list: () => requests.get<Template[]>('/templates'),
  templateDetails: (id: string) =>
    requests.get<Template>(`/templates/directchild/${id}`),
  templateDetailsAll: (id: string) =>
    requests.get<Template>(`/templates/${id}`),
  updateTemplate: (template: Template) =>
    axios.put<void>(`/templates/${template.templateId}`, template),
  createTemplateUnderElementType: (elementType: elementTypes) =>
    axios.post<AssetType>('/elementtypes/addtemplate', elementType),
  cloneTemplate: (data: CloneStructure) =>
    axios.post<void>(`/templates/clone`, data),
  gettemplateTypeByElementType: (id: string) =>
    requests.get<Template[]>(`/ElementTypes/GetTemplate/${id}`),
};

const TemplateOptions = {
  createOptionsUnderElements: (element: WorkflowElement) =>
    axios.post<WorkflowElement>('/templateelements/addtemplateoption', element),
  editOptions: (options: WorkflowOptions) =>
    axios.put<WorkflowOptions>(`/templateoptions/${options.optionId}`, options),
  deleteOptionsAPI: (id: string) =>
    axios.delete<WorkflowOptions>(`/templateoptions/${id}`),
};

const TemplateElements = {
  elementDetails: (id: string) =>
    requests.get<WorkflowElement>(`/templateelements/${id}`),
  createElementUnderSubTask: (subtasks: TemplateSubTasks) =>
    axios.post<TemplateSubTasks>(
      '/templatesubtasks/addtemplateelement',
      subtasks,
    ),
  deleteElement: (id: string) => axios.delete(`templateelements/${id}`),
  editElement: (element: WorkflowElement) =>
    axios.put<WorkflowElement>(
      `/templateelements/${element.elementId}`,
      element,
    ),
  elementToggleOffEditAPI: (elementId: string) =>
    axios.put(`/TemplateElements/toggleOnOff/${elementId}`),
  cloneElements: (data: CloneStructure) =>
    axios.post<void>(`/templateelements/clone`, data),
};

const TemplateTasks = {
  taskDetails: (id: string) =>
    requests.get<TemplateTask>(`/templatetasks/${id}`),
  createTaskUnderTemplate: (template: Template) =>
    axios.post<Template>('/templates/addtemplatetask', template),
  deleteTask: (id: string) => axios.delete(`templatetasks/${id}`),
  arrangeIndex: (id: string) =>
    axios.put(`/TemplateTasks/arrangeIndex?TemplateId=${id}`),
  editTask: (tasks: TemplateTask) =>
    axios.put<void>(`/templatetasks/${tasks.taskId}`, tasks),
  cloneTasks: (data: CloneStructure) =>
    axios.post<void>(`/templatetasks/clone`, data),
  updateTatForSubTask: (subTaskId: string, updatedTat: string) =>
    axios.put<any>(`/TemplateSubTasks/taTTime/${subTaskId}?tat=${updatedTat}`),
  parallelTask: (params: { TemplateId: string; currentTaskIndex: number }) =>
    axios.get<ParallelTask[]>(`/TemplateTasks/parallelTask`, { params }),
  parallelTaskSelected: (params: { taskId: string }) =>
  axios.get<{dependencyTask: string, isParallel: boolean}>(`/NFAI/parallelTaskSelected`, { params }),
  parallelTaskUpdate:(taskId:string , params:{dependencyTask: string|any[]|undefined, isParallel: boolean|undefined})=>{
    axios.put(`/NFAI/parallelTaskUpdate?taskId=${taskId}`, params)
  }
};

const TemplateSubtasks = {
  subTaskDetails: (id: string) =>
    requests.get<TemplateSubTasks>(`/templatesubtasks/${id}`),
  createSubtaskUnderTask: (tasks: TemplateTask) =>
    axios.post<TemplateTask>('/templatetasks/addtemplatesubtask', tasks),
  deleteSubtask: (id: string) => axios.delete(`templatesubtasks/${id}`),
  arrangeIndex: (id: string) =>
    axios.put(`/TemplateSubTasks/arrangeIndex?TaskId=${id}`),
  editSubTask: (subtasks: TemplateSubTasks) =>
    axios.put<TemplateSubTasks>(
      `/templatesubtasks/${subtasks.subTaskId}`,
      subtasks,
    ),
  subTaskToggleOffEditAPI: (subTaskId: string) =>
    axios.put(`/TemplateSubTasks/toggleOnOff/${subTaskId}`),
  cloneSubTasks: (data: CloneStructure) =>
    axios.post<void>(`/templatesubtasks/clone`, data),
  reArrangeOrder: (params: any, elementId: string) =>
    axios.put<MetaDataET>(
      `/TemplateElements/indexRearrange/${elementId}`,
      null,
      { params },
    ),
};

const Deliveries = {
  listAllDelivery: () =>
    requests.get<DeliveryRequest[]>('/deliveryrequest/ListDRItem'),
  create: (activity: Activity) =>
    axios.post<void>(
      `/DeliveryRequest/AddDeliveryRequest?id=${activity.id}`,
      activity,
    ),
  update: (delivery: DeliveryRequest) =>
    axios.put<DeliveryRequest>(`/deliveryrequest/${delivery.id}`, delivery),
};

const InventoryDelivery = {
  OrderRegister: (id: string, payload: OrderRegisterPayLoadType) =>
    axios.put<string>(
      `/InventoryDelivery/orderRegister?deliveryRequestId=${id}`,
      payload,
    ),
  Approve: (id: string, approve: boolean, comments: string) =>
    axios.put<string>(
      `/InventoryDelivery/approve?deliveryRequestId=${id}&approve=${approve}&comments=${comments}`,
    ),
  AssignPicker: (id: string, pickerName: string, pickerContact: string) =>
    axios.put<string>(
      `/InventoryDelivery/assignPicker?deliveryRequestId=${id}&pickerName=${pickerName}&pickerPhoneNo=${pickerContact}`,
    ),
  Delivery: (id: string, payload: InventoryDelivery_DeliveryPayload) =>
    axios.put<string>(
      `/InventoryDelivery/delivery?deliveryRequestId=${id}`,
      payload,
    ),
  AssetTrackingStatus: (itemId: string, status: string) =>
    axios.put(
      `/InventoryDelivery/assetTrackingStatus?itemId=${itemId}&status=${status}`,
    ),
  OrderTrackingStatus: (itemId: string, status: string) =>
    axios.put(
      `/InventoryDelivery/orderTrackingStatus?itemId=${itemId}&status=${status}`,
    ),
  // listWorkLevel: () =>
  //   axios.get<{ id: string; title: string }[]>(`/HFC/outwardRequestWorkLevel`),
  // filterTitleByWL: (params: { itemGroupId: string }) =>
  //   axios.get<{ id: string; title: string; print?: string }[]>(
  //     `/HFC/outwardRequestFilmTitle`,
  //     { params },
  //   ),
  // outwardRequestValidation: (params: { itemId: string }) =>
  //   axios.get<string>(`/HFC/outwardRequestValidation`, { params }),
  outwardReqDetails: (params: { itemId: string }) =>
    axios.get<any>(`/HFC/oRFilmTitleBarcode`, { params }),
};

const Inwards = {
  create: (activity: Activity) =>
    axios.post<void>(`/items/updateinward?id=${activity.id}`, activity),
  inwardVerifyUpdate: (params: {
    id: string;
    verify: boolean;
    comment: string;
  }) => axios.put<any>(`/Inwards/verify`, null, { params }),
  inwardApproveUpdate: (params: {
    id: string;
    approve: boolean;
    comment: string;
  }) => axios.put<any>(`/Inwards/approve`, null, { params }),
  inwardPickerAssignUpdate: (params: {
    id: string;
    pickerName: string;
    pickerPhoneNo: string;
  }) => axios.put<any>(`/Inwards/assignPicker`, null, { params }),
  inwardMoveToVaultUpdate: (params: { id: string; comment: string }) =>
    axios.put<any>(`/Inwards/move`, null, { params }),
  searchInwardTableDetails: (
    params: {
      item?: string;
      PageNumber: number;
      PageSize: number;
    },
    name: string,
  ) => axios.get<any[]>(`/Inwards/${name}`, { params }),
  sortInwardTableDetails: (
    params: {
      orderBy: string;
      name: string;
      PageNumber: number;
      PageSize: number;
    },
    name: string,
  ) => axios.get<number>(`/Inwards/${name}/sort`, { params }),
  countInwardTableDetails: (
    params: {
      item: string;
    },
    name: string,
  ) => axios.get<number>(`/Inwards/${name}/count`, { params }),
  getInwardRequestItem: (itemId: string) =>
    axios.get<any>(`/Inwards/itemId?itemId=${itemId}`),
};

const Outwards = {
  searchOutwardTableDetails: (
    params: {
      item: string;
      PageNumber: number;
      PageSize: number;
    },
    name: string,
  ) => axios.get<any[]>(`/Outward/${name}`, { params }),
  sortOutwardTableDetails: (
    params: {
      orderBy: string;
      name: string;
      PageNumber: number;
      PageSize: number;
    },
    name: string,
  ) => axios.get<number>(`/Outward/${name}/sort`, { params }),
  countOutwardTableDetails: (
    params: {
      item: string;
    },
    name: string,
  ) => axios.get<number>(`/Outward/${name}/count`, { params }),
  outwardUnvaultUpdate: (params: { id: string; comment: string }) =>
    axios.put<any>(`/Outward/unVault`, null, { params }),
  outwardVerifyUpdate: (params: {
    id: string;
    verify: boolean;
    comment: string;
  }) => axios.put<any>(`/Outward/verify`, null, { params }),
  outwardApproveUpdate: (params: {
    id: string;
    approve: boolean;
    comment: string;
  }) => axios.put<any>(`/Outward/approve`, null, { params }),
  outwardPickerAssignUpdate: (params: {
    id: string;
    pickerName: string;
    pickerPhoneNo: string;
  }) => axios.put<any>(`/Outward/assignPicker`, null, { params }),
  outwardMoveUpdate: (params: { id: string; comment: string }) =>
    axios.put<any>(`/Outward/move`, null, { params }),
  outwardPackUpdate: (params: { id: string; comment: string }) =>
    axios.put<any>(`/Outward/pack`, null, { params }),
  outwardBillingUpdate: (params: {
    id: string;
    type: string;
    cost: string;
    code: string;
  }) => axios.put<any>(`/Outward/billing`, null, { params }),
};

const Role = {
  listRoles: () => requests.get<any[]>('/rolesandpermissions/template'),
  Roledetails: (id: string) =>
    requests.get<Roles>(`/rolesandpermissions/template${id}`),
  userListRoles: () => requests.get<any[]>('/RolesAndPermissions/TemplateName'),
  createRole: (roles: Roles) =>
    axios.post<void>('/rolesandpermissions/template', roles),
  roleSetting: () =>
    axios.get<roleSettingType[]>(`/RolesAndPermissions/RoleSetting`),
  modes: (id: string, mode: number) =>
    axios.put(`/RolesAndPermissions/mode?Id=${id}&mode=${mode}`),
};

const Pages = {
  pageDetails: (id: string) => requests.get<RolePages>(`/pages/${id}`),
};

const Components = {
  componentDetails: (id: string) =>
    requests.get<RoleComponents>(`/components/${id}`),
};

const RoleIDs = {
  roleIDs: () =>
    requests.get<RolesAndPermissionsID[]>('/rolesandpermissions/rolesid'),
  roleIDs2: (id: string) =>
    requests.get<RolesAndPermissionsID[]>(
      `RolesAndPermissions/Roles_ID?RoleId=${id}`,
    ),
  createRoleIDs: (roleID: RolesAndPermissionsID) =>
    axios.post<void>('/rolesandpermissions/rolesid', roleID),
  deleteRoleIDS: (id: string) =>
    axios.delete<void>(`/rolesandpermissions/rolesid${id}`),
};

const Reports = {
  details: (id: string) =>
    requests.get<Activity>(`/reports/clonedassets?cloned_from=${id}`),
  sectionMultipledetails: (id: string) =>
    requests.get<Activity[]>(
      `/reports/SectionMultiple?section_multiple_from=${id}`,
    ),
  reportsWithPaginationPost: (
    pagenum: number,
    pageSize: number,
    data: string[],
  ) =>
    axios.post<any>(
      `/AssetReport/MetadataReport?PageNumber=${pagenum}&PageSize=${pageSize}`,
      data,
    ),
  linkExisting: (id: string) =>
    requests.get<Activity[]>(`/pages/existing?id=${id}`),
  PivotReportKeys: (
    startdate: any,
    enddate: any,
    pagenum: number,
    pagesize: number,
  ) =>
    axios.get<any>(
      `/metadatareports/pivotreportkey?countrycode=${navigator.language}&startdate=${startdate}&enddate=${enddate}&pagenumber=${pagenum}&pagesize=${pagesize}`,
    ),
  loadPivotData: (
    startdate: any,
    enddate: any,
    pagenum: number,
    pagesize: number,
    data: string[],
  ) =>
    axios.post<any>(
      `/AssetReport/PivotReport?startdate=${startdate}&enddate=${enddate}&PageNumber=${pagenum}&PageSize=${pagesize}`,
      data,
    ),
  saveAsPivot: (data: pivotData) => axios.post<any>(`/pivotreport`, data),
  getSaveasPivotReports: (companyName: string) =>
    requests.get<pivotData[]>(`/pivotreport?customername=${companyName}`),
  getSingleSaveAsPivotReports: (id: string) =>
    requests.get<pivotData>(`/pivotreport/${id}`),
  updateSingleUserReport: (data: pivotData) =>
    requests.put<pivotData>(`/pivotreport`, data),
  deleteSingleUserReport: (id: string) => axios.delete(`/pivotreport/${id}`),
  sectionRemoveLink: (itemId: string, type: string, id: string) =>
    axios.put<void>(
      `/Pages/Physical?ItemId=${itemId}&physical=${type}&ParentId=${id}`,
    ),
  searchListPost: (paramsItems: any, selectedColumns: any) =>
    axios.post<any>(`/AssetReport/MetadataReportSearch/`, selectedColumns, {
      params: paramsItems,
    }),
    smarttrackerSearchListPost:(pagenum:number,params: any) =>
    axios.post<any>(`/Restoration/SmartTracker?pageNo=${pagenum}&pageSize=${20}`,  params ),
    smarttrackerSearchListCount:(params: any) =>
    axios.post<any>(`/Restoration/SmartTrackerCount`,  params ),

    searchListCount: (paramsItems: any, selectedColumns: any) =>
    axios.post<any>(`/AssetReport/MetadataReportSearchCount`, selectedColumns, {
      params: paramsItems,
    }),
  sortMetaDataReport: (
    data: string,
    direction: string,
    pagenum: number,
    selectedData: string[],
  ) =>
    axios.post<any>(
      `/AssetReport/MetadataReportSort?headerName=${data}&orderBy=${direction}&PageNumber=${pagenum}&PageSize=${10}`,
      selectedData,
    ),
  loadTotalMetaDataCount: () => requests.get<any>(`Items/metadatareportcount`),
  loadPivotCount: (startdate: string, enddate: string) =>
    requests.get<any>(
      `/AssetReport/PivotReportCount?startdate=${startdate}&enddate=${enddate}`,
    ),
  downloadMetaDataEmail: (data: string[]) =>
    axios.post<any>(`items/metadatareportemail`, data),
  getPinnedIds: (userId: string) =>
    axios.get<any>(`/pivotreport/pinnedassets?userId=${userId}`),
  postPinnedIds: (data: PinnedInterface) =>
    axios.post<any>(`/pivotreport/createpinnedassets`, data),
  editPinnedIds: (data: PinnedInterface) =>
    axios.put<any>(`/pivotreport/updatepinnedassets`, data),
  loadNotFilmFestivalPagination: (pagenum: number) =>
    requests.get<Activity[]>(
      `/pages/LVPCMS_NotFF?pagenumber=${pagenum}&PageSize=${10}`,
    ),
  loadFilmFestivalPagination: (pagenum: number) =>
    requests.get<Activity[]>(
      `/pages/LVPCMS_OnlyFF?pagenumber=${pagenum}&PageSize=${10}`,
    ),
  loadFFReport: (id: string) =>
    requests.get<any>(`Pages/ExistingReport?itemid=${id}`),
  ExistingLink: (itemId: string, chidId: string) =>
    axios.put<void>(`/pages/addexisting?itemid=${itemId}&parentid=${chidId}`),
  CheckUser: (userId: string) =>
    requests.get<void>(`/Kanban/AssignUserItem?Id=${userId}`),
  AllocateMultipleItemToMultipleUser: (itemId: string, userID: string[]) =>
    axios.post<string>(
      `/AllocateUser/assignMultiUsersToItems?itemsId=${itemId}`,
      userID,
    ),
  RemoveMultipleUserFromMultipleItems: (itemId: string, userID: string[]) =>
    axios.delete<string>(
      `/AllocateUser/removeMultiUsersFromItems?itemsId=${itemId}`,
      { data: userID },
    ),
  metadataReportKeys: (details: string) =>
    requests.get<string[]>(
      `/MetadataKeys/Report_Key/Customer_Name/Key?customer=${details}`,
    ),
  metadataHeadersPostItemID: (id: string) =>
    axios.post<any>(`/MetadataKeys/ItemMetadataUpdate?Id=${id}`),
  metaDataIDItemVerify: (data: string[]) =>
    axios.post<any>(`/MetadataKeys/ItemVerify`, data),
  postDropdownParentItems: (pagenumber: number, data: any) =>
    axios.post<any>(
      `/AssetReport/MetadataReport/Parent?PageNumber=${pagenumber}&PageSize=${10}`,
      data,
    ),
  postDropdownParentItemsCount: () =>
    axios.get<any>(`/AssetReport/MetadataReportCount/Parent`),
  getRolesAndPermissionTaskAndSubtask: (id: string) =>
    axios.get(`/AssetReport/smartTrackerPermissionCheck?itemId=${id}`),
};

const assetList = {
  getItemsMetaData: () =>
    axios.get<any>(`/AssetReport/ListItemDDWithSearchHeader`),
  getItemsList: (
    payload: string[],
    params: { searchData: string; pageNo: number; pageSize: number },
  ) => axios.put<any>(`/AssetReport/ListItemDDWithSearch`, payload, { params }),
};

const KanbanList = {
  Kanban: () => requests.get<any>(`/Kanban`),
  KanbanData: (itemId: string, chidId: string) =>
    axios.put<void>(`Kanban?Id=${itemId}&Status=${chidId}`),
  kanbanItemId: (subtaskId: string) =>
    requests.get<void>(`Kanban/ItemId?SubtaskId=${subtaskId}`),
};

const TaskFormTaskServices = {
  updateCompleteSubTask: (payload: {
    templateId: string;
    itemId: string;
    taskId: string;
    subtaskId: string;
  }) =>
    axios.put<any>(
      `/WorkflowSubTasks/editWorkflowCompleteST`,
      {},
      {
        params: payload,
      },
    ),
  updateComponentsValuesInHistory: (payload: {
    taskName: string;
    subTaskName: string;
    elementName: string;
    elementValue: string;
    dateTime: string;
    status: string;
  }) => requests.post<any>(`/ViewTemplate`, payload),
};

const QuickScan = {
  BarcodeDetailsAPI: (data: string[]) =>
    axios.post<Activity[]>(`/QuickScanProcess/Order`, data),
  Idbased_subtask: (data: string[]) =>
    axios.post<string[]>(`/QuickScanProcess/Subtask`, data),
  statuschanger: (itemId: string, chidId: string) =>
    axios.put<void>(`Kanban?Id=${itemId}&Status=${chidId}`),
  BarcodeUnorder: (data: string[]) =>
    axios.post<Activity[]>(`/QuickScanProcess/WithoutOrder`, data),
  WithoutBarcodeInventory: (params: {
    typeId: string;
    elementId: string;
    currentTask: string;
    currentSubtask: string;
    status: string;
  }) => axios.get(`/QuickScanProcess/listItemId?,`, { params }),
  InventoryStatusChangerPut: (
    itemId: string,
    status: number,
    orderStatus: string,
  ) =>
    axios.put(
      `/QuickScanProcess/updateStatus?itemId=${itemId}&status=${status}&orderStatus=${orderStatus}`,
    ),
};

const adltracking = {
  getEmployeedetails: (pageNumber: number, pageSize: number, employeeId: string) =>
    axios.get(
      `/ADL/GetAllEmployeedetails?PageNumber=${pageNumber}&PageSize=${pageSize}&employeeId=${employeeId}`,
    ),
  assingHead: (payload: adlEmployeeDetails) =>
    axios.post(`ADL/AddEmpRptHead`, payload),
  employeeCount: (employeeId: string) => axios.get(`ADL/getEmployeecount?employeeId=${employeeId}`),
  getEmployeeinformationbyID: (emplId: string) =>
    axios.get(`ADL/getEmployeedetailsbyEmpId?employeeId=${emplId}`),
  removeEmplyee: (empId: string) =>
    axios.put(`ADL/RemoveEmployee?employeeId=${empId}`),
  addNewShift: (payload: shiftMasterData) =>
    axios.post(`ADL/addShiftMaster`, payload),
  countShiftName: (shiftName: string) =>
    axios.get(`ADL/shiftCount?shiftName=${shiftName}`),
  returnAllShiftDetails: () => axios.get(`ADL/shiftDetailsReturn`),
  uploadShiftRoaster: (payLoadData: shiftRoasterData[]) =>
    axios.post(`ADL/importShitRoaster`, payLoadData),
  getEmpUnderLead: (empId: string) => axios.get(`/ADL/ListUsers?empId=${empId}`),
  updateShiftRoster: (payLoadData: ShiftUpdate) =>
    axios.put(`/Restoration/ADLShiftUpdate`, payLoadData),
  shiftRosterDetails: (empId: string, PageNo: number, PageSize: number) => axios.get(`/Restoration/ADLShiftDetails?empId=${empId}&PageNo=${PageNo}&PageSize=${PageSize}`),
  countShiftData: () => axios.get(`ADL/shiftTotalCount`),
  leadID: () => axios.get(`ADL/getPlIdfromReportHead`),
  loadingShiftcode: () => axios.get(`ADL/getAllShiftCode`),
  shiftChange: (payLoadChangeData: shiftRoasterChangeData) =>
    axios.put(`ADL/shiftChange`, payLoadChangeData),

  shiftExtendition: (payLoadExtData: shiftRoasterExt) =>
    axios.put(`ADL/shiftExtUpdate`, payLoadExtData),
  unLockEmployee: (PayLoading: employeeLockedInfo) =>
    axios.post(`ADL/updateRejectHistory`, PayLoading),
  shiftDatabyPlwise: (stDate: string, endDate: string, leadIds: string) =>
    axios.get(
      `ADL/getDateWisebyPlid?startDate=${stDate}&endDate=${endDate}&leadId=${leadIds}`,
    ),
  getLockedEmployeeCount: () => axios.get(`ADL/getLockedEmployeecount`),
  loadLockedEmployeeDetails: (pageNumber: number, pageSize: number) =>
    axios.get(
      `ADL/getLockEmployeeDetails?PageNumber=${pageNumber}&PageSize=${pageSize}`,
    ),
};

const Restoration = {
  ItemListGetAllDetailsGet: (PageNumber: number, PageSize: number) =>
    axios.get(
      `/Restoration/ItemListGetAllDetails?PageNumber=${PageNumber}&PageSize=${PageSize}`,
    ),
  titleWiseSummary: (
    titleCode: string[],
    PageNumber: number,
    PageSize: number,
  ) =>
    axios.post<any>(
      `/Restoration/TitleWiseSummaryReport?PageNumber=${PageNumber}&PageSize=${PageSize}`,
      titleCode,
    ),
  titleWiseSummaryCount: () => axios.get(`/Restoration/titleSummaryCount`),
  leadEmpIDs: () => axios.get(`/Restoration/PlEmpId`),
  reelWiseSummary: (TitleCode:string) => axios.get(`/Restoration/ReelwiseSummary?TitleCode=${TitleCode}`),
  plWiseSummary: (TitleCode:string) => axios.get(`/Restoration/PlwiseSummary?TitleCode=${TitleCode}`),
  qualitySummary: () => axios.get(`/Restoration/ShotDefects`),
  pcEmpId: () => axios.get(`/Restoration/PCEmpId`),
  empId: () => axios.get(`/Restoration/OperatorEmpId`),
  teamNameLists: () => axios.get(`/Restoration/GetTeamlist`),
  empName: (employeeId: string) =>
    axios.get(`/Restoration/EmployeeName?employeeId=${employeeId}`),
  getAllTitleBasedDefectsAPI: (titleID: string) =>
    axios.get(`/Restoration/SearchshotDefectsbyTitleCode?titleCode=${titleID}`),
  getDateBasedDefectReportAPI: (stDate: string, endDate: string) =>
    axios.get(
      `Restoration/searchShotDefectbyDate?fromDate=${stDate}&toDate=${endDate}`,
    ),
  getDateBasedOperatorResponceReportAPI: (stDate: string, endDate: string) =>
    axios.get(`Hour/detailsForDate?fromDate=${stDate}&toDate=${endDate}`),
  getTitleBasedOperatorPerforanceReportAPI: (tileName: string) =>
    axios.get(`Hour/operatorProductivitybyTitle?titleNameInput=${tileName}`),
  getDateBasedQualityResponceReportAPI: (stDate: string, endDate: string) =>
    axios.get(
      `Hour/qualityTeamDateWisePerformance?fromDate=${stDate}&toDate=${endDate}`,
    ),
  cutliststatusreport: (titleCode: string) =>axios.get(`/Restoration/Cutliststatus?Titlecode=${titleCode}`),
  getTitlecode: () => axios.get(`/Restoration/getTitlecode`),
  titleCodecount: (titleCode: string) =>
    axios.get(`Restoration/titlecodecount?Titlecode=${titleCode}`),
  qualityteamtitle: (titleCode: string) =>
    axios.get(
      `Restoration/TitlewiseQcPerformancetracker?Titlecode=${titleCode}`,
    ),
  operatorPerformance: () =>
    axios.get<operatorPerformanceType[]>(`/Restoration/OperatorSummary`),
  restoratioHoursUpdate: (params: {
    itemLevelId: string;
    taskId: string;
    taskName: string;
    subTaskId: string;
    subTaskName: string;
    currentUser: string;
    actionName: string;
  }) => axios.post(`/Hour/restoratioHoursUpdate`, params),
  NFAIrestoHoursUpdate: (params: {
    itemLevelId: string;
    taskId: string;
    taskName: string;
    subTaskId: string;
    subTaskName: string;
    currentUser: string;
    actionName: string;
  }) => axios.post(`/Hour/NFAIrestoHoursUpdate`, params),
  TaskWiseOverAllTitle:(fromDate:string,toDate:string)=>axios.get(`/RestorationReport/TaskWiseOverAllTitle?fromDate=${fromDate}&toDate=${toDate}`),
  AllEmployeeDetails:()=>axios.get(`/RestorationReport/AllEmployeeDetails`),
  productionTitleWiseReport:(titleCode:string)=>axios.get(`/RestorationReport/productionTitleWiseReport?TitleCode=${titleCode}`),
  productionDateWiseReport:(fromDate:string,toDate:string)=>axios.get(`/RestorationReport/productionDateWiseReport?fromDate=${fromDate}&toDate=${toDate}`),
  ClusterReport:(fromDate:string,toDate:string,clusterEmployeeId:string)=>axios.get(`/RestorationReport/ClusterReport?fromDate=${fromDate}&toDate=${toDate}&ClusterEmployeeId=${clusterEmployeeId}`),
  ClusterHeadEmployeeID:()=>axios.get(`/RestorationReport/ClusterHeadEmployeeID`),
  TitleDashboardReport:(fromDate:string,toDate:string)=>axios.get(`/RestorationReport/TitleDashboardReport?fromDate=${fromDate}&toDate=${toDate}`),
  AllowTitleDashboardReport: (params: any) => axios.post(`/RestorationReport/UpdateMovementTime`, params),
  ClusterCapacityReport:(fromDate:string,toDate:string)=>axios.get(`/RestorationEmployee/ClusterCapacityNew?fromDate=${fromDate}&toDate=${toDate}`),
  ClusterindividualCapacityReport:(fromDate:string,toDate:string)=>axios.get(`/RestorationEmployee/individualEmployeecCapacity?fromDate=${fromDate}&toDate=${toDate}`),
  DayWiseHours:(startDate:string,FinishDate:string,titleChecked:boolean,dayHour:boolean)=>axios.get(`RestorationEmployee/DayWiseHours?startDate=${startDate}&FinishDate=${FinishDate}&TitleChecked=${titleChecked}&dayHour=${dayHour}`),
  RestorationProductivityApiCall:(startDate:string,FinishDate:string)=>axios.get(`/RestorationEmployee/ProductivityReport?startDate=${startDate}&FinishDate=${FinishDate}`),
  monthlyProductivityReport:(Month:string,Year:string,employeeId:string)=>axios.get(`/RestorationEmployee/MonthlyProductivityReport?Month=${Month}&Year=${Year}&employeeId=${employeeId}`),
  monthlyProductivityReportByDate:(fromDate:string,toDate:string,employeeId:string)=>axios.get(`/RestorationEmployee/MonthlyProductivityDatewise?fromDate=${fromDate}&toDate=${toDate}&employeeId=${employeeId}`),
  monthlyProductivityReportYear:()=>axios.get(`/RestorationEmployee/ProductionYears`),
  monthlyProductivityReportMonth:(Year:string)=>axios.get(`/RestorationEmployee/ProductionMonth?year=${Year}`),
  basicPCRReport:(TitleCode:string)=>axios.get(`/PCRReport/PCRBasicReport?TitleCode=${TitleCode}`),
  commentsgetPCRReport:(TitleCode:string)=>axios.get(`/PCRReport/PCRComments?TitleCode=${TitleCode}`),
  createComments:(payload:pcrCommentsPayload)=>axios.post(`/PCRReport/createComment`,payload),
  removeComments:(payload:pcrCommentsPayload)=>axios.put(`/PCRReport/RemoveComment`,payload),
  createpcrDetail:(inputPayload:pcrReportdetails)=>axios.post(`/PCRReport/createPCRreport`,inputPayload),
  pcrInformation:(title:string)=>axios.get(`/PCRReport/getPCRInformation?TitleCode=${title}`),
  createFRRadress:(inputFrrAddressPayload:frrReportAddress)=>axios.post(`/PCRReport/createFrrAddress`,inputFrrAddressPayload),
  CreateFrrDetails:(FrrDetailPayload:FrrInformData)=>axios.post(`/PCRReport/CreateFrrDetails`,FrrDetailPayload),
  defectListDetails:()=>axios.get(`/PCRReport/DefectTypeList`),
  FrrAddressList:(TitleCode:string)=>axios.get(`/PCRReport/FrrAddressList?TitleName=${TitleCode}`),
  removeFrrAddress:(TitleCode:string,reelName:string,addressNo:number)=>axios.delete(`/PCRReport/RemoveFrrAddrees?addressNo=${addressNo}&TitleCode=${TitleCode}&reelName=${reelName}`),
  getFinalRestorationReport:(titleCode:string)=>axios.get(`/PCRReport/FinalRestorationReport?TitleCode=${titleCode}`),
  getHoneyCombStatusReport:()=>axios.get(`/RestorationEmployee/HoneyCombStatusReport`),
  operationReportApi:(Month:string,Year:string)=>axios.get(`/Restoration/opsReport?Month=${Month}&Year=${Year}`),
  operationReportByClusterWiseApi:(Month:string,Year:string, fromDate: string, toDate: string)=>axios.get(`/RestorationCluster/ClusterSummaryViewDetails?Month=${Month}&Year=${Year}&fromDate=${fromDate}&toDate=${toDate}`),
  ProductivityReportbyTitleBreakUpApi:(Month:string,Year:string,employeeId:string)=>axios.get(`/RestorationCluster/ProductivityReportbyTitleBreakUp?Month=${Month}&Year=${Year}&employeeId=${employeeId}`),
  ProductivityReportbyTitleBreakUpApiByDate:(fromDate:string,toDate:string,employeeId:string)=>axios.get(`/RestorationCluster/ProductivityTitleBreakUpDatewise?fromDate=${fromDate}&toDate=${toDate}&employeeId=${employeeId}`),
  OpenTitle:()=>axios.get(`/RestorationTitleManagement/OpenTitle`), 
  TitleDashboardInProgess:()=>axios.get(`/RestorationReport/TitleDashboardInProgessTitle`),
  TitleDashboardReportSearchByTitle:(titleName:string)=>axios.get(`/RestorationReport/TitleDashboardReportSearchByTitle?inputTitleCode=${titleName}`),
  TitleDashboardReportSearchByProjectName:(titleName:string)=>axios.get(`/RestorationReport/TitleDashboardReportSearchByTitleName?inputTitleName=${titleName}`),
  TitleDashboardReportSearchByClientName:(titleName:string)=>axios.get(`/RestorationReport/TitleDashboardReportSearchByClient?inputClientName=${titleName}`),
  FrrInformationGetandGenerateComments:(titleCode:string)=>axios.post(`/PCRReport/CreateFrrDetailsInformation?TitleCode=${titleCode}`),
  // monthlyProductivityReport:(Month:string,Year:string)=>axios.get(`/RestorationEmployee/MonthlyProductivityReport?Month=${Month}&Year=${Year}`),
  ReelSmartrackerSearchCount:(titleCode:string,subtask:string)=>axios.get(`/Restoration/ReelSmartrackerSearchCount?TitleCode=${titleCode}&SubTask=${subtask}`),
  ReelSmartrackerSearch:(titleCode:string,subtask:string)=> axios.get(`/Restoration/ReelSmartrackerSearch?TitleCode=${titleCode}&SubTask=${subtask}`),
  reelStatusUpdate:(status:string,params:qtSubtaskTypes)=> axios.put(`/Restoration/reelStatusUpdate?status=${status}`, params),
  reelInputOutputPathUpdate:(params:{reelId: string,input_Path: string,output_Path: string})=> axios.put(`/Restoration/reelInputOutputPathUpdate`, params),
  hoursMissingEmployeeDetails:(startDate: string, FinishDate: string) => axios.get(`/RestorationEmployee/hcHoursmissingSummary?startDate=${startDate}&FinishDate=${FinishDate}`),
  dayWiseHours: (startDate: string, FinishDate: string, TitleChecked: boolean, dayHour: boolean)=> axios.get(`RestorationEmployee/DayWiseHours?startDate=${startDate}&FinishDate=${FinishDate}&TitleChecked=${TitleChecked}&dayHour=${dayHour}`),
  titleProductivityReportData: (TitleCode: string) => axios.get(`RestorationEmployee/TitleProductivityReport?TitleCode=${TitleCode}`),
  titleProductivityReportDataByDate: (startDate: string, FinishDate: string) => axios.get(`RestorationEmployee/ProductivityReport?startDate=${startDate}&FinishDate=${FinishDate}`),
  titleCodeforCR: ()=>axios.get(`/RestorationTitleManagement/parentTitleDropDown`),
  assetHideCR: (Itemid: string)=> axios.put(`/RestorationTitleManagement/childitemsHide?Itemid=${Itemid}`),
  assetOpenCR: (Itemid: string)=> axios.put(`/RestorationTitleManagement/HoldTitleReopen?Itemid=${Itemid}`),
  ClientqcIsActiveUpdate: (subtaskId:string) => axios.put(`/Hour/ClientqcIsActiveUpdate?subtaskids=${subtaskId}`)
};
const SingleTitlePageTitleCreate={
  MetaDataFieldName:()=>axios.get(`/TitleCreate/MetaDataFieldName`),
  CGTitleCreate:(metaDataList:MetaDataTemplate[])=>axios.post(`TitleCreate/CGTitleCreate`,metaDataList),
  TitleInventoryCrate:(itemId:string,Inventorylist:InventoryList[])=>axios.post(`/RestorationTitleManagement/CreateTitleInventory?itemId=${itemId}`,Inventorylist),
  ReelInventoryDetails:(title:string)=>axios.get(`/RestorationTitleManagement/TitleReelInventoryList?TitleCode=${title}`),
  DeleteReelName:(reelId:string)=>axios.delete(`/RestorationTitleManagement/RemoveTitleInventory?reelId=${reelId}`),
  returnTitleID:(TitleCode:string)=>axios.get(`/RestorationTitleManagement/ItemIdUsingTitle?TitleCode=${TitleCode}`),
  returnTitleReelList:(itemid:string)=>axios.get(`/RestorationTitleManagement/TitleReelNameList?itemId=${itemid}`),
  TitleInventoryUpdate:(Inventorylist:InventoryListDetails)=>axios.put(`/RestorationTitleManagement/TitleReelInventoryUpdate`,Inventorylist),
}  
const CGReports = {
  hoursCalculate: () =>
    axios.get<manDaysType[]>(`/CGReport/MandaysHoursCalculate`),
};

const ColorRestoration = {
  performanceReportDateWise: (fromDate: string, toDate: string, TitleBreak: boolean)=>
    axios.get(`ColorRestoration/qualityTeamDateWisePerformance?fromDate=${fromDate}&toDate=${toDate}&TitleBeak=${TitleBreak}`),
  performanceReportTitleWise: (TitleCode: string)=>
    axios.get(`ColorRestoration/qualityTeamTitleWisePerformance?TitleCode=${TitleCode}`),
  artistPerformanceReportDateWise: (fromDate: string, toDate: string, TitleBreak: boolean)=>
    axios.get(`ColorRestoration/artistPerformanceReport?fromDate=${fromDate}&toDate=${toDate}&TitleBeak=${TitleBreak}`),
  artistPerformanceReportTitleWise: (TitleCode: string)=> 
    axios.get(`ColorRestoration/artistTitleWisePerformanceReport?TitleCode=${TitleCode}`),
  colorizationMonthlyProductivityReportDateWise: (Month: string, Year: string)=>
    axios.get(`ColorRestoration/ColorizationMonthlyProductivityReport?Month=${Month}&Year=${Year}`),
  colorizationMonthlyProductivityReportDateWiseByTitle: (Month: string, Year: string)=>
    axios.get(`ColorRestoration/ColorizationMonthlyProductivityReportbyTitleBreak?Month=${Month}&Year=${Year}`),
  ColorizationYearsUpdate:()=>axios.get(`ColorRestoration/ColorizationgWorkingYears`)
};

const CRMAssetTracking = {
   createCRMAsset: (params: {title: string, company: string, building: string, department: string, location: string, category: string | string[], make_Or_Model_No: string, model_Sn: string, asset_Moved_To: string, remarks: string})=>
    axios.post(`/CRMAsset/CreateCRMAsset`, params),
   updateCRMAsset: (params: {id:string,title: string, company: string, building: string, department: string, location: string, category: string | string[], make_Or_Model_No: string, model_Sn: string, asset_Moved_To: string, remarks: string})=>
    axios.put(`/CRMAsset/UpdateCRMAsset`, params),
   departmentSearch: (PageNumber: number, PageSize: number, Department: string)=>
    axios.get(`/CRMAsset/DepartmentSearch?PageNumber=${PageNumber}&PageSize=${PageSize}&Department=${Department}`),
   departmentSearchCount: () => axios.get(`/CRMAsset/CrmAssetCount`),
   crmList: (PageNumber: number, PageSize: number)=>
    axios.get(`/CRMAsset/CrmList?PageNumber=${PageNumber}&PageSize=${PageSize}`),
   crmCount: ()=> axios.get(`/CRMAsset/CountCRMAsset`),
   searchCRMAsset: (PageNumber: number, PageSize:number, params: any) => 
    axios.post(`/CRMAsset/crmAssetSearchValues?PageNumber=${PageNumber}&PageSize=${PageSize}`, params),
   assetSearchCount: (params: any) => axios.post(`/CRMAsset/CrmAssetSearchCount`, params),
   receivedCRMAsset:(id: string, UserName: string, receivedstatus: boolean) => axios.put(`/CRMAsset/crmAssetReceivedUpdate?id=${id}&UserName=${UserName}&receivedstatus=${receivedstatus}`),
   DepartmentNameList: () => axios.get(`/CRMAsset/DepartmentNameList`),
}

const email = {
  list: () => requests.get<EmailNew[]>('/emails'),
  sendNewEmail: (email: EmailNew) => axios.post<void>('/emails', email),
  emailMessageSearchAPI: (params: {
    item: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<any>(`/Emails/search`, { params }),
  emailMessageCountAPI: (params: { item: string }) =>
    axios.get<any>(`/Emails/count`, { params }),
  emailMessageSortAPI: (params: {
    orderBy: string;
    name: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<any>(`/Emails/sort`, { params }),
  // ----------------- email alert -------------------- //
  emailAlertSearchAPI: (params: {
    item: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<any>(`/Rejects/alert/search`, { params }),
  emailAlertCountAPI: (params: { item: string }) =>
    axios.get<any>(`/Rejects/alert/count`, { params }),
  emailAlertSortAPI: (params: {
    orderBy: string;
    name: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<any>(`/Rejects/alert/sort`, { params }),
  rejectNotification: (payload: EmailNew) =>
    axios.post(`/Emails/subtaskReject`, payload),
};

const Reschedule = {
  updateCreateOrder: (itemId: string, templateId: string) =>
    axios.put<void>(
      `/ReSchedule/Schedule?itemId=${itemId}&templateId=${templateId}`,
    ),
  rescheduleTasks: (
    itemId: string,
    templateId: string,
    isExtend: boolean,
    payload: rescheduleTasksPayloadType[],
  ) =>
    axios.put<string>(
      `ReSchedule?itemId=${itemId}&templateId=${templateId}&isExtend=${isExtend}`,
      payload,
    ),
};

const AssetTracking = {
  reportDataInfo: (params: { pageNumber: number; pageSize: number }) =>
    axios.get<any>(`/Restoration/ItemTracking`, { params }),
  workLevelBasedItems: (params: {
    workLevel: string;
    pageNumber: number;
    pageSize: number;
  }) => axios.get<any>(`/Restoration/ItemTrackingDetails`, { params }),
};

const SideBarAPIContainer = {
  getFormDetailsAPI: () => axios.get<any>(`/MasterReport`),
};

const dynamicMaster = {
  getMasterDetailsAPI: () => axios.get<any>(`/MasterReport`),
  postItemGroupDetailsAPI: (params: { title: string }) =>
    axios.post<any>(`/MasterReport/ItemGroup`, null, { params }),
  postMasterDetailsAPI: (payload: {
    title: string;
    dateTime: string;
    metadata: MetaDataElement[];
    icon?: string;
  }) => axios.post<any>(`/MasterReport`, payload),
  deleteMasterReport: (params: { masterId: string }) =>
    axios.delete<any>(`/MasterReport`, { params }),
};

const newMasterReport = {
  getHistory: (params: {
    assetId: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<any>(`History/masterAsset`, { params }),
  updateHistory: (payload: {
    historyId: string;
    assetId: string;
    userId: string;
    name: string;
    department: string;
    imageUrl: string;
    status: string;
    date: string;
  }) => axios.post<any>(`History/masterAsset`, payload),
  getMetadataList: (params: { masterId: string }) =>
    axios.get<any>(`/MasterReport/Register`, { params }),
  getMasterMetaDataBasedOnID: (payload: { masterId: string; ids: string[] }) =>
    axios.post<any>(`/Masters/masterElementMetadata`, payload),
  postMetadataList: (
    payload: {
      assetId: string;
      components: MetaDataElement[];
    },
    masterId: string,
  ) =>
    axios.post<any>(`/MasterReport/Register`, payload, {
      params: { masterId },
    }),
  assignUserMasterUpdate: (assetId: string, payload: string[]) =>
    axios.post<any>(
      `/MasterReport/PDFLAddRemoveMultiUser?assetId=${assetId}`,
      payload,
    ),
  getMasterAsset: (params: { assetId: string }) =>
    axios.get<any>(`/MasterReport/masterAsset`, { params }),
  getMasterName: (params: { masterId: string }) =>
    axios.get<any>(`/MasterReport/masterName`, { params }),
  updateMasterAsset: (payload: {
    assetId: string;
    components: MetaDataElement[];
  }) => axios.put<any>(`/MasterReport/masterAsset`, payload),
  /**
   * Table
   */
  getAllMasterReports: (params: {
    masterId: string;
    searchData: string;
    PageNumber: number;
    PageSize: number;
  }) => axios.get<any>(`/MasterReport/Report`, { params }),
  getMasterReportsCount: (params: { masterId: string; searchData: string }) =>
    axios.get<any>(`/MasterReport/ReportCount`, { params }),
  deleteMasterAsset: (params: { assetId: string }) =>
    axios.delete<any>(`/MasterReport/masterAsset`, { params }),
};

const SmartTracker = {
  titleCodeGet: () => axios.get<any>(`/Restoration/getTitlecode`),
  plEmpIdGet: () => axios.get<any>(`/Restoration/PlEmpId`),
  OperationEmpIdGet: () => axios.get<any>(`/Restoration/OperatorEmpId`),
  smartTrackerItemStatusChangerAPI: (payload: any) =>
    axios.put(`/Tracker/SmartTracker`, payload),
UpdateRestorationTaskStatusInformationGet: (payload:any)=> axios.put<any>(`/Restoration/UpdateRestorationTaskStatusInformation`,payload),
RestorationinputOutPath:(itemId:string) => axios.get(`/Restoration/RestorationinputOutPath?ItemID=${itemId}`),
RejectHistory:(itemId:string)=> axios.get(`/Restoration/RejectHistory?ItemID=${itemId}`),
UpdateinputOutPath:(itemId:string,InputPath:string,OutputPath:string,frrInformation:string)=> axios.put(`/Restoration/UpdateinputOutPath?ItemID=${itemId}&InputPath=${InputPath}&OutputPath=${OutputPath}&FrrInformation=${frrInformation}`),
createRejectHistory:(params:any[])=> axios.post(`/Restoration/createRejectHistory`, params),
DefectTypes:()=>axios.get(`/Restoration/DefectTypes`),
SeverityTypes:()=>axios.get(`/Restoration/SeverityTypes`),
OperatorRemainter:()=>axios.get(`/Hour/OperatorRemainter`),
restorationAssetType:(itemId:string)=>axios.get<any>(`/AssetTypes/restorationAssetType?ItemId=${itemId}`),
smartDeleteList:(Title: string)=>axios.get(`/Restoration/smartDeleteList?Title=${Title}`)
};  

const viewPage = {
  viewHistory: (params: { itemId: string; pageNo: number; pageSize: number }) =>
    axios.get<HistoryViewItemLevel[]>(`/MediaAssets/history`, { params }),
  viewHistoryCount: (params: { itemId: string }) =>
    axios.get<number>(`/MediaAssets/historyCount`, { params }),
  getParentMetaData: (params: { itemId: string }) =>
    axios.get<metadataType[]>(`/MediaAssets/metadata`, { params }),
  getHFCMetadata:(params:{itemId: string})=> 
  axios.get<HFCmetadataType[]>(`/HFCMediaServices/mediaAssetMetadata`, {params}),
  getChildMetaData: (params: { itemId: string; elementId: string }) =>
    axios.get<metadataType[]>(`/MediaAssets/childMetadata`, {
      params,
    }),
  technicalMetaData: (params: { itemId: string }) =>
    axios.get<metadataType[]>(`/MediaAssets/technical`, { params }),
  physicalAssets: (params: { itemId: string }) =>
    axios.get<physicalAssetsType>(`/MediaAssets/physicalAsset`, { params }),
  HFCphysicalAssets: (params: { itemId: string }) =>
    axios.get<HFCphysicalAssetsType>(`/HFCMediaServices/mediaAssetPhysical`, { params }),
  itemDetailsAlone: (params: { itemId: string }) =>
    axios.get<itemDetailsType>(`/MediaAssets/details`, { params }),
  assignedUsersList: (params: { itemId: string }) =>
    axios.get<assignUserType[]>(`/MediaAssets/assignedUser`, { params }),
  unAssignedUsersList: (params: {
    itemId: string;
    displayName: string;
    pageNo: number;
    pageSize: number;
  }) => axios.get<assignUserType[]>(`/MediaAssets/unAssignedUser`, { params }),
  unAssignedUsersCount: (params: { itemId: string; displayName: string }) =>
    axios.get<number>(`/MediaAssets/unAssignedUserCount`, { params }),
  addUserToItem: (params: { itemId: string; userId: string }) =>
    axios.post<string>(`/MediaAssets/addUser`, null, { params }),
  removeUserFromItem: (params: { itemId: string; userId: string }) =>
    axios.delete<string>(`/MediaAssets/removeUser`, { params }),
  activeOrder: (params: { itemId: string }) =>
    axios.get<activeOrderType>(`/MediaAssets/activeOrder`, { params }),
  workFlowProcessChanges: (payload: {
    itemId: string;
    currentTask: string;
    currentSubtask: string;
    resolveSubtaskId: string;
    actionerName: string;
    status: number;
  }) =>
    axios.put<workFlowUpdateResponse>(
      `/MediaAssets/WorkflowProcessChange`,
      payload,
    ),
  NFAIworkFlowProcessChanges: (payload: {
    itemId: string;
    templateId: string;
    currentTaskId: string;
    nextTaskId: string;
    currentSubtaskId: string;
    nextSubTaskId: string;
    actionerName: string;
    totalTask: number;
    afterRejectSubtaskName:string
  }) =>
    axios.put<NFAIworkFlowUpdateResponse>(
      `/Workflows/subtaskComplete`,
      payload,
    ),
  prodCount: (payload: {
    itemId: string;
    prodCount: number;
    tolTask: number;
    compTask: number;
    result: string;
  }) => axios.put<any>(`/MediaAssets/prodPlanCount`, payload),
  itemFiles: (params: { itemId: string }) =>
    axios.get<FilesFolderType[]>(`/MediaAssets/files`, { params }),
  updateHistory: (params: { itemId: string }, payload: historyPayloadType) =>
    axios.put<string>(`/MediaAssets/addHistory`, payload, { params }),
};

const HFC = {
  getHFCPhysical: (params: { itemId: string }) =>
    axios.get<{ physicalCaseCount: number; pigeonHole: string }>(
      `/HFC/physicalCaseCount`,
      { params },
    ),
  outwardRegisterSave: (payload: hfcOutwardRegisterPayload) =>
    axios.put(`/HFC/outwardRegisterItemMetadata`, payload),
  getMetadatForDelivery: (params: { itemId: string }) =>
    axios.get<{ name: string; value: string }[]>(`/HFC/itemDeliveryMetadata`, {
      params,
    }),
  circuitCreation: (params: { itemId: string }, payload: circuitCreationPOST) =>
    axios.post<string>(`/HFC/addCircuit`, payload, { params }),
  getCircuit: (params: { itemId: string }) =>
    axios.get<circuitType[]>(`/HFC/circuit`, { params }),
  deleteCircuit: (params: { itemId: string }) =>
    axios.delete(`/HFC/removeCircuit`, { params }),
  // tagValidationHfc: (
  //   payload: tagValidationType,
  //   params: { moveTo: boolean } = { moveTo: false },
  // ) => axios.post<string>(`/HFC/tagValidation`, payload, { params }),
  editReturnDateCircuit: (params: {
    itemId: string;
    index: number;
    returnDate: string | undefined;
  }) => axios.put(`/HFC/returnDateCircuit`, null, { params }),
  savePrintForEachItem: (params: { print: string }, payload: string[]) =>
    axios.post(`/HFC/print`, payload, { params }),
  registerAsset:()=>axios.get(`HFCMediaServices/registerAssetType`),
  registerElementType:(assetId:string)=>axios.get(`HFCMediaServices/registerElementType?assetId=${assetId}`),
  registerMetadata:(elementId:string)=>axios.get(`HFCMediaServices/registerMetadata?elementId=${elementId}`),
  registerWorkLevel:(title:string)=>axios.post(`/HFCMediaServices/registerWorkLevel?title=${title}`),
  HFCreelBarcodeVal:(payload:any[])=>axios.post(`HFCMediaServices/ReelBarcodeVal`, payload),
  registerAssetHFC:(itemGroupId:string, payload:any)=>axios.post(`/HFCMediaServices/registerAsset?itemGroupId=${itemGroupId}`, payload),
  assetIdGenerate:(title:string, typeName:string|undefined, elementName:string|undefined)=> axios.get(`HFCMediaServices/assetIdGenerate?title=${title}&typeName=${typeName}&elementName=${elementName}`),
  // getPigeonHole: (params: {
  //   vaultId: string;
  //   rackNo: string;
  //   shelfNo: string;
  // }) => axios.get<string[]>(`/HFC/pigeonHole`, { params }),
  HFCscanAsset:(PageNumber:number, PageSize:number, payload:string[])=>axios.post(`/HFCMovement/scanAsset?PageNumber=${PageNumber}&PageSize=${PageSize}`, payload),
  HFCscanCount:(payload:string[])=>axios.post(`/HFCMovement/scanCount`, payload),
  HFCscanAssetBarcodes:(payload:string[])=> axios.post(`HFCMovement/scanAssetBarcodes`, payload),
  HFCVault:()=>axios.get(`/HFCMovement/Vault`),
  HFCRoom:( vaultId: string )=>axios.get(`/HFCMovement/Room?VaultId=${vaultId}`),
  HFCAisle: (VaultId:string, roomName:string)=> axios.get(`/HFCMovement/AsileNo?VaultId=${VaultId}&roomName=${roomName}`),
  HFCShelf:(VaultId:string, roomName:string, asileNo:string)=>axios.get(`/HFCMovement/Shelf?VaultId=${VaultId}&roomName=${roomName}&asileNo=${asileNo}`),
  HFCTag:(VaultId:string, payload:any)=>axios.post(`HFCMovement/Tag?containerBarcode=${VaultId}`, payload),
  HFClistAssetWAssetId:(asset:string)=>axios.get(`HFCShipping/listAssetWAssetId?asset=${asset}`),
  HFCAssetDetails:(asset:string)=>axios.get(`/HFCShipping/AssetDetails?asset=${asset}`),
  HFCRequestedBy:()=> axios.get(`/HFCShipping/RequestBy`),
  HFCAssetRegister:(payload: ShippingRequest)=> 
    axios.post(`/HFCShipping/registerAssettype`, payload),
  HFCShipperSelected:(shippingId: string)=>axios.get<HFCShipperInfo>(`/HFCShipping/ShippingAssetValue?shippingId=${shippingId}`),
  HFCServiceAssign:(requestId: string)=>axios.get<HFCServiceInfo>(`/HFCServiceRequest/customerRequest?requestId=${requestId}`),
  HFCCustomerrequest:(requestId: string)=>axios.get<HFCServiceInfo>(`/HFCServiceRequest/customerRequest?requestId=${requestId}`),
  HFCShippingPrepSelected: (shippingId: string | null)=> axios.get(`/HFCShipping/TaskElements?shippingId=${shippingId}`),
  HFCServiceElements:(shippingId: string | null)=>axios.get(`/HFCServiceRequest/ServiceElements?shippingId=${shippingId}`),
  HFCListTemplates:(elementId:string)=>axios.get(`/HFCShipping/ListTemplates?ElementId=${elementId}`),
  HFCTemplateDetails: (elementId:string)=> axios.get(`HFCShipping/templateDetail?templateId=${elementId}`),
  HFCWorkflows:(payload:WorkFlowTemplate|undefined)=> axios.post(`/Workflows`, payload),
  HFCAssignTask:(payload:any)=> axios.put(`/HFCShipping/AssignTask`, payload),
  HFCPullApprove:(shippingId:string, approve:boolean)=> axios.put(`/HFCShipping/PullAssetApprove?shippingId=${shippingId}&approve=${approve}`),
  HFCStartTask:(shippingId:string)=>axios.put(`/HFCShipping/startTask?shippingId=${shippingId}`),
  HFCServiceStartTask:(shippingId:string, status:number)=>axios.put(`/HFCServiceRequest/ServiceProcess?shippingId=${shippingId}&status=${status}`),
  HFCTaskStatus:(shippingId:string, status:number)=> axios.put(`/HFCShipping/TaskStatus?shippingId=${shippingId}&status=${status}`),
  HFCContainerDetails:(shippingId:string)=> axios.get(`/HFCShipping/ContainerDetails?shippingId=${shippingId}`),
  HFCTaskElementUpdate:(payload:any)=>axios.put(`/HFCShipping/TaskElementsUpdate`, payload),
  HFCDeliveryRequestDelete:(shippingId:string)=> axios.delete(`/HFCShipping/Request?shippingId=${shippingId}`),
  HFCShippingAsset:(shippingId: string,orderId:any )=> axios.put(`/HFCShipping/ShippingAsset?shippingId=${shippingId}&orderId=${orderId}`),
  HFCShippingAssetReceipt:(shippingId:string)=> axios.get(`/HFCShipping/ShippingAssetReceipt?shippingId=${shippingId}`),
  HFCReceivingAsset:(shippingId:string|undefined)=> axios.put(`/HFCReceiving/ReceivingAsset?shippingId=${shippingId}`),
  HFCServiceRequest:(ElementId:string)=> axios.get(`/HFCServiceRequest/ListTemplates?ElementId=${ElementId}`),
  HFCRegisterCustomAsset:(Registerpayload:any, payload: ShippingRequest)=> axios.post(`/HFCServiceRequest/registerCustomerRequest?templateId=${Registerpayload.templateId}&templateName=${Registerpayload.templateName}&firstService=${Registerpayload.firstService}&external=${Registerpayload.external}`, payload),
  HFCUSerRole:()=> axios.get(`HFCServiceRequest/userRoles`),
  HFCAssignUser:(requestId:string, rollName:string)=>axios.put(`/HFCServiceRequest/assignTaskToPersonnal?requestId=${requestId}&rollName=${rollName}`),
  HFCServicesL3:()=>axios.get(`/HFCServiceRequest/services`),
  HFCaddHistory:(payload:any)=> axios.post(`HFC/CreateHistory`, payload),
  HFCtitleSearch:(title:any)=> axios.get(`/HFCMovement/TitleSearch?title=${title}`),
  HFCRegisterTitle:(title:any)=> axios.get(`/HFC/AssetGroup?title=${title}`),
  HFCInspectionDetails:(shippingId:string)=> axios.put(`/HFCServiceRequest/InspectionNotes?shippingId=${shippingId}`),
  HFCInspection:(shippingId:string)=> axios.put(`/HFCServiceRequest/Inspection?shippingId=${shippingId}`),
  HFCSingleCircuitDelete:(payload:any)=> axios.delete(`/HFC/singleCircuit?itemId=${payload.itemId}&index=${payload.index}`),
  HFCUpdateGrade:(assetId:string, payload:any)=> axios.put(`/HFC/UpdateGrade?assetId=${assetId}`, payload),
  CircuitHistory:(itemId:string|undefined, pageNo:number, pageSize:number)=> axios.get(`/HFC/CircuitHistory?itemId=${itemId}&pageNo=${pageNo}&pageSize=${pageSize}`),
  AssociatedElements:(itemId:string)=>axios.get(`/HFC/associatedElements?itemId=${itemId}`),
  Fedex:(payload:any)=> axios.post(`/Fedex/GenerateLabel`, payload)
};

const NFAI = {
  allowReelAnalysis: (params: { itemId: string }) =>
    axios.get<string>(`/NFAI/allowReelAnalysis`, { params }),
  allowRestoration: (params: { itemId: string }) =>
    axios.get<string>(`/NFAI/allowRestoration`, { params }),
  allowReelPDFupload: (params: { itemId: string }) =>
    axios.get<string>(`/NFAI/reelWiseFile`, { params }),
  nfaiPDF2CSV: (params: { ItemId: string; path: string }) =>
    axios.get<nfaiPDF2CSVtype>(`/NFAI/pdfToCSV`, { params }),
  createReelItem: (
    params: { itemGroupId: string; itemId: string },
    payload: any,
  ) => axios.post(`/NFAI/reelWiseItemUpload`, payload, { params }),
  countUpdatePostReelCreation: (params: {
    reelCount: number;
    taskCount: number;
  }) => axios.put(`/NFAI/reelWiseCountUpdate`, null, { params }),
  registerScanData: (payload: acquisitionScanType) =>
    axios.post<registerScanResponse>(`/NewAcquisition/scanData`, payload),
  addItemGroupAcquisition: (payload: string[], params: { customer: string }) =>
    axios.post<addItemGroupRes[]>(`/NewAcquisition/addItemGroup`, payload, {
      params,
    }),
  createItemAcquisition: (
    payload: any,
    params: { itemGroupId: string; title: string },
  ) => axios.post(`/NewAcquisition/registerItemUpload`, payload, { params }),
  updateCountPostBatchUpload: (params: {
    itemCount: number;
    taskCount: number;
  }) => axios.put(`/NewAcquisition/registerItemCount`, null, { params }),
  getCutList: (params: { parentId: string }) =>
    axios.get<cutlistDetailsType>(`/NFAI/CutList`, { params }),
  postCutlist: (parentId: string, params: any) =>
    axios.post(`/NFAI/cutlistUpload?itemGroupId=${parentId}`, params),
  CutlistreelAnalysisInformation: (itemId: string) =>
    axios.get(`/Restoration/reelAnalysisInformation?itemId=${itemId}`),
  IsparallelsubTaskUpdate: (SubTaskId:string,IsParallelsubtask:boolean) => axios.put(`/NFAI/IsparallelsubTaskUpdate?SubTaskId=${SubTaskId}&IsParallelsubtask=${IsParallelsubtask}`),
  ColorGradingcheckparameters: (title:string) => axios.put(`/Restoration/checkparameters?checkprameter=${title}`),
  
  checkparametersCheckReport: () => axios.put(`/Restoration/checkparametersCheckReport`),
  checkparametersChecklist: () => axios.put(`/Restoration/checkparametersChecklist`),
  checkparametersSubtitles: () => axios.put(`/Restoration/checkparametersSubtitles`),
  checkparametersAllReports: () => axios.put(`/Restoration/checkparametersAllReports`),
  checkparametersRestorationClips: () => axios.put(`/Restoration/checkparametersRestorationClips`),
  checkparametersPictureRestoration: () => axios.put(`/Restoration/checkparametersPictureRestoration`),
  checkparametersOpen: (itemId: string) => axios.put(`/Restoration/checkparametersOpen?itemId=${itemId}`),
  checkparametersEncrypted: (title: string, itemId: string) => axios.put(`/Restoration/checkparametersEncrypted?title=${title}&itemId=${itemId}`),
  
  // GetFilteredItemDetails: () => axios.get(`/NFAI/GetFilteredItemDetails`),
   PostFilteredItemDetails: (params:PostFilteredItemDetailsTypes) => axios.put(`/NFAI/PostFilteredItemDetails?title=${params.title}&currentTask=${params.currentTask}&currentSubtask=${params.currentSubtask}&status=${params.status}&Previoustask=${params.Previoustask}&PreviousSubtask=${params.PreviousSubtask}&PageNumber=${params.PageNumber}&PageSize=${params.PageSize}`),
   GetFilteredItemDetailscount: (params:PostFilteredItemDetailsTypes) => axios.put(`/NFAI/GetFilteredItemDetailscount?title=${params.title}&currentTask=${params.currentTask}&currentSubtask=${params.currentSubtask}&status=${params.status}&Previoustask=${params.Previoustask}&PreviousSubtask=${params.PreviousSubtask}&PageNumber=${params.PageNumber}&PageSize=${params.PageSize}`),
   extractPdfInfo: (itemId:string,path:string) => axios.get(`/NFAI/extractPdfInfo?itemId=${itemId}&path=${path}`),
   NFAILevel2: () => axios.get(`/NFAI/NFAILevel2`),
    NFAILevel3: (currentTask:string) => axios.get(`/NFAI/NFAILevel3?currentTask=${currentTask}`),
  getReportByTitleCode: (FilmTitle: string[]) => axios.post(`/NFAI/NFAISearchshotDefectsbyFilmTitle`, FilmTitle),
  getReportByDate: (startDate: string, endDate: string, location:string) => axios.get(`/NFAI/NFAISearchshotDefectsbyDate?startDate=${startDate}&endDate=${endDate}&location=${location}`),
  getCheckParametersEncrypted: (checkprameter: string) => axios.put(`/Restoration/checkparametersEncrypted?checkprameter=${checkprameter}`),
  Ffv1QcReport:(itemId:string, subtaskId:string)=>axios.get(`/NFAI/FFV1QCReport?itemId=${itemId}&subtaskId=${subtaskId}`),
  Ffv1QcReport1:(itemId:string, subtaskId:string)=>axios.get(`Restoration/DCPEncryptedReport?itemId=${itemId}&subtaskId=${subtaskId}`),
  getValueForDeliverables: (itemId: string, subTaskId: string) => axios.put(`/Restoration/deliverablesQCReport?itemId=${itemId}&subTaskId=${subTaskId}`),
  getLTOBarCode: (itemId: string) => axios.get(`/Restoration/LTOBarCode?itemId=${itemId}`),
  LTOBatchLabel:(payload:any) => axios.post(`/NFAI/LTOGroup`, payload),
  Consolidated: (itemId:string, subtaskId:string, DeliverablesId:string, colorGradingId:string, RestorationId:string) => axios.get(`/NFAI/Consolidated?itemId=${itemId}&subtaskId=${subtaskId}&DeliverablesId=${DeliverablesId}&NFHMColorGradingId=${colorGradingId}&RestorationId=${RestorationId}`),
  NoOfframes:(subtaskId:string ,elementValue:string) => (`/NFAI/NoOfframes?subtaskId=${subtaskId}&elementValue=${elementValue}`)
};

const manageAssetPage = {
  itemDeleteDetails: (params: { itemId: string }) =>
    axios.get<itemDeleteDetailsType>(`/MediaAssets/itemPermanentDelete`, {
      params,
    }),
  itemDelete: (payload: itemDeleteDetailsType) =>
    axios.delete<itemDeleteResponse>(`/MediaAssets/item`, { data: payload }),
};

const AssetRental = {
  masterAssetRentalApproval: (masterId: string, Params: any) =>
    axios.put<string>(
      `/MasterReport/masterAssetRentalApproval?masterId=${masterId}`,
      Params,
    ),
  AMTransactionReport: (masterId: string, Params: any) =>
    axios.post(`/LVPCMS/AMTransactionReport?masterId=${masterId}`, Params),
};

const PCProcessCsvReport = {
  pcprocessACategory: () =>
    axios.get<PcProcessCsvReport[]>(`/PcProcess/pcprocessACategory`),
};

const NFAIReport = {
  AVSyncParrentData: (itemId: string, params: ReelInformation[]) =>
    axios.put<any>(`/NFAI/AVSyncParrentData?itemId=${itemId}`, params),
    AVSyncfromParrent:(itemId:string)=>axios.get(`/NFAI/AVSyncfromParrent?itemId=${itemId}`),
    reelAnalysis:(itemId:string,path:string,fileName:string)=>axios.put(`/NFAIRestoReport/reelAnalysisFileCopy?itemId=${itemId}&path=${path}&fileName=${fileName}`),
    AssetIDUpdate:(elementId:string,path:string)=>axios.put(`/NFAIRestoReport/AssetIDUpdate?ElementId=${elementId}&csvdestinationPath=${path}`),
    getDataManagement:(itemId:string)=>axios.put(`/NFAIRestoReport/DataManagement?itemId=${itemId}`),
    getCutlistPreivew:(itemId:string,reelNo:string,startFrame:number,endFrame:number)=>axios.get(`/NFAIRestoReport/ViewCutlist?&itemId=${itemId}&reelNo=${reelNo}&startFrame=${startFrame}&endFrame=${endFrame}`),
    CutlistVerification:(itemId:string)=>axios.get(`/NFAIRestoReport/CutlistVerification?itemId=${itemId}`),
    getRoleBasedUserList:()=>axios.get(`/NFAIRestoReport/roleBasedUserList`),
    getParentLinkStatus:(itemId:string)=>axios.get(`/NFAIRestoReport/parentLinkStatus?itemId=${itemId}`),
    shotClassification:(itemId:string)=>axios.put(`/NFAIRestoReport/shotClassification?itemId=${itemId}`),
    CutlistAggregation:(itemId:string)=>axios.put(`/NFAIRestoReport/CutlistAggregation?itemId=${itemId}`),
    ImageRestorationSort:(itemId:string)=>axios.put(`/NFAIRestoReport/ImageRestorationSort?itemId=${itemId}`),
    InputFormatUpdate:(elementId:string,path:string)=>axios.put(`/NFAIRestoReport/InputFormatUpdate?ElementId=${elementId}&csvdestinationPath=${path}`),
    deliveryFormatUpdate:(elementId:string,path:string)=>axios.put(`/NFAIRestoReport/deliveryFormatUpdate?ElementId=${elementId}&csvdestinationPath=${path}`),
    filmElementUpdate:(elementId:string,path:string)=>axios.put(`/NFAIRestoReport/filmElementUpdate?ElementId=${elementId}&csvdestinationPath=${path}`),
    filmTypeUpdate:(elementId:string,path:string)=>axios.put(`/NFAIRestoReport/filmTypeUpdate?ElementId=${elementId}&csvdestinationPath=${path}`),
    filmGaugeUpdate:(elementId:string,path:string)=>axios.put(`/NFAIRestoReport/filmGaugeUpdate?ElementId=${elementId}&csvdestinationPath=${path}`),
   nfaiCutlsitStatusReport:(title:any)=>axios.post(`/NFAIProductionSupport/nfaiCutlsitStatusReport`, title),
    updateCutlistUserReallocation: (params:reAllocationTypes)=> 
       axios.post(`/MediaAssets/updateCutlistUserReallocation?itemId=${params.itemId}&userId=${params.userId}&EmpId=${params.employeeId}&EmpName=${params.employeeName}&Startframe=${params.startFrame}&Endframe=${params.endFrame}&Totalframe=${params.totalFrame}`),
    CutlistCompleteList: (params:cutlistCompleteTypes) => axios.post(`NFAIRestoration/CutlistCompleteList`, params),
    CutlistCompleteFilmTitle: () => axios.get(`/NFAIRestoration/CutlistCompleteFilmTitle`),
    CutlistcompleteReelFilter: (title:string) => axios.get(`/NFAIRestoration/CutlistcompleteReelFilter?titleName=${title}`),
    NoOfframes: (subtaskId:string,elementValue:string) => axios.get(`/NFAI/NoOfframes?subtaskId=${subtaskId}&elementValue=${elementValue}`),
    NFAITemplateL2:(templateId:string) => axios.get(`/ProdPlanControlller/NFAITemplateL2?templateId=${templateId}`),
    NFAITemplateL3:(templateId:string, currentTask:string) => axios.get(`/ProdPlanControlller/NFAITemplateL3?templateId=${templateId}&currentTask=${currentTask}`),
    NFAITaskActivate: (params:any) => axios.post(`/NFAIRestoReport/ActivateWorkflowTask`, params),
    QCworkingHours: (params:any) => axios.post(`/NFAIRestoration/QCworkingHours`,  params ),

    MetadataUploadMastring: (subtaskId:string ,files:any) => axios.post(`/NFAIRestoration/MetadataUploadMastring?fileUrl=${files}&SubtaskId=${subtaskId}`),
    CheckSumReader: (files:any, subtaskId:string, subtaskName:string) => axios.get(`/NFAIRestoration/CheckSumReader?url=${files}&SubtaskId=${subtaskId}&SubtaskName=${subtaskName}`),
    deliverables: (mediaType:number, srtFileAvailable:string, subtaskId:string, file:any, params:any) => axios.post(`/NFAIRestoration/deliverables?filePath=${file}&mediaType=${mediaType}&srtFileAvailable=${srtFileAvailable}&subTaskId=${subtaskId}`, params),
    DeliverableCheckSumReader: (mediaType:number,subtaskId:string, file:any, params:any) => axios.post(`/NFAIRestoration/DeliverableCheckSumReader?filePath=${file}&subTaskId=${subtaskId}&mediaType=${mediaType}`, params),
    dcpEncrypted: (htmlFilePath:string,itemId:string, srtFileAvailable:string, subtask:string, params:any) => axios.put(`/NFAIRestoration/dcp-encrypted?htmlFilePath=${htmlFilePath}&itemLevelId=${itemId}&srtFileAvailable=${srtFileAvailable}&subtask=${subtask.toString()}`, params),
    Restoration_File_upload: (file: string, imageRestorationId: string, supervisorFeedbackId: string, itemId: string) => axios.get(`/NFAIproduction/RestorationFileUploadReport?filePath=${file}&imgRestoID=${imageRestorationId}&NFHMrestoID=${supervisorFeedbackId}&ItemID=${itemId}`),
};

const NFAIRestoTimeSheet ={
  getProjectList: ()=> axios.get(`/NFAIRestorationTimeSheet/NFAIProjectList`),
  getScopeOfWorkList: (department: string)=> axios.get(`/NFAIRestorationTimeSheet/NFAIProjectScopeOfWork?department=${department}`),
  saveTimeSheet: (params: TimeSheetData)=> axios.post(`/NFAIRestorationTimeSheet/NFAIProjectTimeSheetEntry`, params),
  NFAIMasteringProjectTimeSheetEntry: (params: NewTimeSheetEntry)=> axios.post(`/NFAIRestorationTimeSheet/NFAIMasteringProjectTimeSheetEntry`, params),
  updateTimeSheet: (params: UpdatedTimeSheetData)=> axios.put(`/NFAIRestorationTimeSheet/NFAIProjectTimeSheetUpdate`, params),
  deleteTimeSheet: (id: string)=> axios.delete(`/NFAIRestorationTimeSheet/NFAIProjectTimeSheetDelete?id=${id}`),
  getTimeSheetEntries: (id: string, department: string)=> axios.get(`/NFAIRestorationTimeSheet/NFAIProjectTimeSheetList?id=${id}&department=${department}`),
  getTimeSheetByTitle: (titleId: string, department: string, emp_id: string)=> axios.get(`/NFAIRestorationTimeSheet/NFAITimeSheetSearchByTitle?titleId=${titleId}&department=${department}&Emp_id=${emp_id}`),
  getTimeSheetByDate: (StartDate: string, Enddate: string, department: string, emp_id: string)=> axios.get(`/NFAIRestorationTimeSheet/NFAITimeSheetSearchByDate?StartDate=${StartDate}&Enddate=${Enddate}&department=${department}&Emp_id=${emp_id}`),
  getTimeSheetByDateForAdmin: (StartDate: string, Enddate: string, department: string)=> axios.get(`/NFAIRestorationTimeSheet/NFAITimeSheetSearchByDateForAdmin?StartDate=${StartDate}&Enddate=${Enddate}&department=${department}`),
  getTimeSheetByTeam: (department: string)=> axios.get(`/NFAIRestorationTimeSheet/NFAITimeSheetSearchByTeam?department=${department}`),
    NFAIRestorationTimeSheet: (params: {
      StartDate: string;
      EndDate: string;
      department: string;
      ProjectId?: string;
      EmpId?: string;
    }) =>
      axios.get(`/NFAIRestorationTimeSheet/NFAIProductivity`, {
        params: {
          StartDate: params.StartDate,
          EndDate: params.EndDate, // ⚠️ case-sensitive
          department: params.department,
          ...(params.ProjectId && { ProjectId: params.ProjectId }),
          ...(params.EmpId && { EmpId: params.EmpId }),
        },
      }),
  getTimeSheetByEmployee: (employee: string)=> axios.get(`/NFAIRestorationTimeSheet/NFAITimeSheetSearchByEmployee?Employee=${employee}`),
  NFAIAllocatedMasteringSubtask: (params:any) => axios.post(`/NFAIRestorationTimeSheet/NFAIAllocatedMasteringSubtask`, params),
  NFAITimeSheetProjectForMastering: (userId:string)=> axios.get(`/NFAIRestorationTimeSheet/NFAITimeSheetProjectForMastering?userId=${userId}`),

  NFAIMasteringTeamUserList: (params:any)=> axios.post(`/NFAIRestorationTimeSheet/NFAIMasteringTeamUserList`, params),
  NFAIMasteringTeamUserListDelete: (parentId:string, user: string)=> axios.delete(`/NFAIRestorationTimeSheet/NFAIMasteringTeamUserListDelete?ProjectId=${parentId}&userId=${user}`),

  NFAIProductivityStatusCreate: (params: NFAIProductivityStatusCreate) => axios.post(`/NFAIRestorationTimeSheet/NFAIProductivityStatusCreate`, params),
}

const Mepz ={
  MepzSync:()=>axios.post(`/Mepz/AddItems`)
}

const agent = {
  Activities,
  Account,
  ReceivingsDeliveries,
  Profiles,
  Vaults,
  Departments,
  Customers,
  WorkLevels,
  Devices,
  ShelfRack,
  Files,
  Templates,
  Deliveries,
  Inwards,
  Order,
  Elements,
  workflowSubtasks,
  AssetTypes,
  subtaskStatus,
  ElementTypes,
  TemplateTasks,
  TemplateSubtasks,
  TemplateElements,
  Role,
  Pages,
  Components,
  RoleIDs,
  TemplateOptions,
  communicationApi,
  apiSetting,
  Reject,
  updateCountOrder,
  workflowStatus,
  Reports,
  MetaDataAssetTypes,
  MetaDataElementType,
  MetaDataElements,
  MetaDataOption,
  mediaAsset,
  Outwards,
  assetList,
  KanbanList,
  Tag,
  CreateOrder,
  ProdPlanning,
  TaskFormTaskServices,
  QuickScan,
  InventoryDelivery,
  Restoration,
  CGReports,
  ColorRestoration,
  email,
  Reschedule,
  AssetTracking,
  SideBarAPIContainer,
  dynamicMaster,
  newMasterReport,
  adltracking,
  SmartTracker,
  viewPage,
  manageAssetPage,
  NFAI,
  HFC,
  AssetRental,
  PCProcessCsvReport,
  NFAIReport,
  Mepz,
  SingleTitlePageTitleCreate,
  CRMAssetTracking,
  NFAIRestoTimeSheet
};

export default agent;
